/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DevRouteImport } from './routes/_dev'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthGuidanceRouteImport } from './routes/_auth/guidance'
import { Route as AuthChooseSalonRouteImport } from './routes/_auth/choose-salon'
import { Route as AuthAgencyRouteImport } from './routes/_auth/agency'
import { Route as AuthOrgIdRouteImport } from './routes/_auth/$orgId'
import { Route as DevUiPreviewIndexRouteImport } from './routes/_dev/ui-preview/index'
import { Route as AuthAgencyIndexRouteImport } from './routes/_auth/agency/index'
import { Route as AuthOrgIdIndexRouteImport } from './routes/_auth/$orgId/index'
import { Route as DevUiPreviewInputsRouteImport } from './routes/_dev/ui-preview/inputs'
import { Route as AuthGoogleBusinessCallbackRouteImport } from './routes/_auth/google-business/callback'
import { Route as AuthAgencyWebsiteRouteImport } from './routes/_auth/agency/website'
import { Route as AuthAgencySocialResultsRouteImport } from './routes/_auth/agency/social-results'
import { Route as AuthAgencySalonResultsRouteImport } from './routes/_auth/agency/salon-results'
import { Route as AuthAgencyRevenueCostsRouteImport } from './routes/_auth/agency/revenue-costs'
import { Route as AuthAgencyProfileRouteImport } from './routes/_auth/agency/profile'
import { Route as AuthAgencyMetaAdsRouteImport } from './routes/_auth/agency/meta-ads'
import { Route as AuthAgencyMembersRouteImport } from './routes/_auth/agency/members'
import { Route as AuthAgencyGoogleRankingRouteImport } from './routes/_auth/agency/google-ranking'
import { Route as AuthAgencyGoogleAdsRouteImport } from './routes/_auth/agency/google-ads'
import { Route as AuthAgencyEinRouteImport } from './routes/_auth/agency/ein'
import { Route as AuthAgencyDemoRequestsRouteImport } from './routes/_auth/agency/demo-requests'
import { Route as AuthOrgIdUserSettingsRouteImport } from './routes/_auth/$orgId/user-settings'
import { Route as AuthOrgIdTurnTrackerRouteImport } from './routes/_auth/$orgId/turn-tracker'
import { Route as AuthOrgIdSalesRouteImport } from './routes/_auth/$orgId/sales'
import { Route as AuthOrgIdReportsRouteImport } from './routes/_auth/$orgId/reports'
import { Route as AuthOrgIdProductsRouteImport } from './routes/_auth/$orgId/products'
import { Route as AuthOrgIdMarketingRouteImport } from './routes/_auth/$orgId/marketing'
import { Route as AuthOrgIdInboxRouteImport } from './routes/_auth/$orgId/inbox'
import { Route as AuthOrgIdGiftCardsRouteImport } from './routes/_auth/$orgId/gift-cards'
import { Route as AuthOrgIdGetStartedRouteImport } from './routes/_auth/$orgId/get-started'
import { Route as AuthOrgIdClientsRouteImport } from './routes/_auth/$orgId/clients'
import { Route as AuthOrgIdCalendarRouteImport } from './routes/_auth/$orgId/calendar'
import { Route as AuthOrgIdBioPageRouteImport } from './routes/_auth/$orgId/bio-page'
import { Route as AuthAgencySalonsIndexRouteImport } from './routes/_auth/agency/salons/index'
import { Route as AuthAgencyMembersIndexRouteImport } from './routes/_auth/agency/members/index'
import { Route as AuthAgencyGuidanceIndexRouteImport } from './routes/_auth/agency/guidance/index'
import { Route as AuthAgencyGoogleBusinessIndexRouteImport } from './routes/_auth/agency/google-business/index'
import { Route as AuthAgencyAdsDoctorIndexRouteImport } from './routes/_auth/agency/ads-doctor/index'
import { Route as AuthOrgIdSettingsIndexRouteImport } from './routes/_auth/$orgId/settings/index'
import { Route as AuthOrgIdReportsIndexRouteImport } from './routes/_auth/$orgId/reports/index'
import { Route as AuthOrgIdMarketingIndexRouteImport } from './routes/_auth/$orgId/marketing/index'
import { Route as AuthMetaCommentToDmCallbackRouteImport } from './routes/_auth/meta/comment-to-dm/callback'
import { Route as AuthAgencySalonsNewRouteImport } from './routes/_auth/agency/salons/new'
import { Route as AuthAgencySalonsShortCodeRouteImport } from './routes/_auth/agency/salons/$shortCode'
import { Route as AuthAgencyMembersNewRouteImport } from './routes/_auth/agency/members/new'
import { Route as AuthAgencyMembersMemberIdRouteImport } from './routes/_auth/agency/members/$memberId'
import { Route as AuthAgencyGuidanceSlugRouteImport } from './routes/_auth/agency/guidance/$slug'
import { Route as AuthAgencyCounterStandsProgramRouteImport } from './routes/_auth/agency/counter-stands/program'
import { Route as AuthAgencyAdsDoctorAskRouteImport } from './routes/_auth/agency/ads-doctor/ask'
import { Route as AuthAgencyAdsDoctorShortCodeRouteImport } from './routes/_auth/agency/ads-doctor/$shortCode'
import { Route as AuthOrgIdSettingsTurnTrackerRouteImport } from './routes/_auth/$orgId/settings/turn-tracker'
import { Route as AuthOrgIdSettingsStaffRouteImport } from './routes/_auth/$orgId/settings/staff'
import { Route as AuthOrgIdSettingsServicesRouteImport } from './routes/_auth/$orgId/settings/services'
import { Route as AuthOrgIdSettingsPlanAndUsageRouteImport } from './routes/_auth/$orgId/settings/plan-and-usage'
import { Route as AuthOrgIdSettingsMarketingAccessRouteImport } from './routes/_auth/$orgId/settings/marketing-access'
import { Route as AuthOrgIdSettingsLinkInBioRouteImport } from './routes/_auth/$orgId/settings/link-in-bio'
import { Route as AuthOrgIdSettingsIntegrationsRouteImport } from './routes/_auth/$orgId/settings/integrations'
import { Route as AuthOrgIdSettingsCheckInRouteImport } from './routes/_auth/$orgId/settings/check-in'
import { Route as AuthOrgIdSettingsCallsRouteImport } from './routes/_auth/$orgId/settings/calls'
import { Route as AuthOrgIdSettingsAppearanceRouteImport } from './routes/_auth/$orgId/settings/appearance'
import { Route as AuthOrgIdReportsTodayRouteImport } from './routes/_auth/$orgId/reports/today'
import { Route as AuthOrgIdReportsTeamRouteImport } from './routes/_auth/$orgId/reports/team'
import { Route as AuthOrgIdReportsSalesRouteImport } from './routes/_auth/$orgId/reports/sales'
import { Route as AuthOrgIdReportsReviewsRouteImport } from './routes/_auth/$orgId/reports/reviews'
import { Route as AuthOrgIdReportsMarketingRouteImport } from './routes/_auth/$orgId/reports/marketing'
import { Route as AuthOrgIdReportsImpactRouteImport } from './routes/_auth/$orgId/reports/impact'
import { Route as AuthOrgIdReportsClientsRouteImport } from './routes/_auth/$orgId/reports/clients'
import { Route as AuthOrgIdReportsAppointmentsRouteImport } from './routes/_auth/$orgId/reports/appointments'
import { Route as AuthOrgIdMarketingTextKeywordsRouteImport } from './routes/_auth/$orgId/marketing/text-keywords'
import { Route as AuthOrgIdMarketingSettingsRouteImport } from './routes/_auth/$orgId/marketing/settings'
import { Route as AuthOrgIdMarketingRewardsCardRouteImport } from './routes/_auth/$orgId/marketing/rewards-card'
import { Route as AuthOrgIdMarketingReviewsRouteImport } from './routes/_auth/$orgId/marketing/reviews'
import { Route as AuthOrgIdMarketingReferralsRouteImport } from './routes/_auth/$orgId/marketing/referrals'
import { Route as AuthOrgIdMarketingQrCodesRouteImport } from './routes/_auth/$orgId/marketing/qr-codes'
import { Route as AuthOrgIdMarketingPrizesRouteImport } from './routes/_auth/$orgId/marketing/prizes'
import { Route as AuthOrgIdMarketingOwnerReportRouteImport } from './routes/_auth/$orgId/marketing/owner-report'
import { Route as AuthOrgIdMarketingNewClientOfferRouteImport } from './routes/_auth/$orgId/marketing/new-client-offer'
import { Route as AuthOrgIdMarketingListingsRouteImport } from './routes/_auth/$orgId/marketing/listings'
import { Route as AuthOrgIdMarketingLeadsRouteImport } from './routes/_auth/$orgId/marketing/leads'
import { Route as AuthOrgIdMarketingHayvenTapRouteImport } from './routes/_auth/$orgId/marketing/hayven-tap'
import { Route as AuthOrgIdMarketingGoogleRankingRouteImport } from './routes/_auth/$orgId/marketing/google-ranking'
import { Route as AuthOrgIdMarketingCreatorsRouteImport } from './routes/_auth/$orgId/marketing/creators'
import { Route as AuthOrgIdMarketingCommentDmRouteImport } from './routes/_auth/$orgId/marketing/comment-dm'
import { Route as AuthOrgIdMarketingCampaignsRouteImport } from './routes/_auth/$orgId/marketing/campaigns'
import { Route as AuthOrgIdMarketingBulkSmsRouteImport } from './routes/_auth/$orgId/marketing/bulk-sms'
import { Route as AuthOrgIdMarketingBioPageRouteImport } from './routes/_auth/$orgId/marketing/bio-page'
import { Route as AuthOrgIdMarketingAnalyticsRouteImport } from './routes/_auth/$orgId/marketing/analytics'
import { Route as AuthOrgIdGiftCardsSettingsRouteImport } from './routes/_auth/$orgId/gift-cards_.settings'
import { Route as AuthOrgIdMarketingReferralsIndexRouteImport } from './routes/_auth/$orgId/marketing/referrals.index'
import { Route as AuthOrgIdMarketingNewClientOfferIndexRouteImport } from './routes/_auth/$orgId/marketing/new-client-offer.index'
import { Route as AuthOrgIdMarketingGoogleRankingIndexRouteImport } from './routes/_auth/$orgId/marketing/google-ranking.index'
import { Route as AuthOrgIdSettingsServicesSameTimeRouteImport } from './routes/_auth/$orgId/settings/services_.same-time'
import { Route as AuthOrgIdSettingsServicesImportRouteImport } from './routes/_auth/$orgId/settings/services_.import'
import { Route as AuthOrgIdSettingsOnlineBookingStaffSelectionRouteImport } from './routes/_auth/$orgId/settings/online-booking.staff-selection'
import { Route as AuthOrgIdSettingsOnlineBookingSetupIntegrationRouteImport } from './routes/_auth/$orgId/settings/online-booking.setup-integration'
import { Route as AuthOrgIdSettingsOnlineBookingPreferencesRouteImport } from './routes/_auth/$orgId/settings/online-booking.preferences'
import { Route as AuthOrgIdSettingsCalendarAppointmentsSchedulingOptionsRouteImport } from './routes/_auth/$orgId/settings/calendar-appointments.scheduling-options'
import { Route as AuthOrgIdSettingsCalendarAppointmentsNoShowProtectionRouteImport } from './routes/_auth/$orgId/settings/calendar-appointments.no-show-protection'
import { Route as AuthOrgIdSettingsCalendarAppointmentsDisplayPreferencesRouteImport } from './routes/_auth/$orgId/settings/calendar-appointments.display-preferences'
import { Route as AuthOrgIdSettingsCalendarAppointmentsCancelRescheduleRouteImport } from './routes/_auth/$orgId/settings/calendar-appointments.cancel-reschedule'
import { Route as AuthOrgIdSettingsBusinessSetupPhoneNumbersRouteImport } from './routes/_auth/$orgId/settings/business-setup.phone-numbers'
import { Route as AuthOrgIdSettingsBusinessSetupPayrollRouteImport } from './routes/_auth/$orgId/settings/business-setup.payroll'
import { Route as AuthOrgIdSettingsBusinessSetupLogoBrandingRouteImport } from './routes/_auth/$orgId/settings/business-setup.logo-branding'
import { Route as AuthOrgIdSettingsBusinessSetupLocationsRouteImport } from './routes/_auth/$orgId/settings/business-setup.locations'
import { Route as AuthOrgIdSettingsBusinessSetupHowYouUseHayvenRouteImport } from './routes/_auth/$orgId/settings/business-setup.how-you-use-hayven'
import { Route as AuthOrgIdSettingsBusinessSetupBusinessHoursRouteImport } from './routes/_auth/$orgId/settings/business-setup.business-hours'
import { Route as AuthOrgIdSettingsBusinessSetupBusinessDetailsRouteImport } from './routes/_auth/$orgId/settings/business-setup.business-details'
import { Route as AuthOrgIdSettingsBusinessSetupAdvancedSettingsRouteImport } from './routes/_auth/$orgId/settings/business-setup.advanced-settings'
import { Route as AuthOrgIdSettingsAutomatedMessagesGiftCardsRouteImport } from './routes/_auth/$orgId/settings/automated-messages.gift-cards'
import { Route as AuthOrgIdSettingsAutomatedMessagesCheckInProcessRouteImport } from './routes/_auth/$orgId/settings/automated-messages.check-in-process'
import { Route as AuthOrgIdSettingsAutomatedMessagesAppointmentRescheduledRouteImport } from './routes/_auth/$orgId/settings/automated-messages.appointment-rescheduled'
import { Route as AuthOrgIdSettingsAutomatedMessagesAppointmentCompletedRouteImport } from './routes/_auth/$orgId/settings/automated-messages.appointment-completed'
import { Route as AuthOrgIdSettingsAutomatedMessagesAppointmentCancelledRouteImport } from './routes/_auth/$orgId/settings/automated-messages.appointment-cancelled'
import { Route as AuthOrgIdSettingsAutomatedMessagesAppointmentBookedRouteImport } from './routes/_auth/$orgId/settings/automated-messages.appointment-booked'
import { Route as AuthOrgIdMarketingTextKeywordsKeywordIdRouteImport } from './routes/_auth/$orgId/marketing/text-keywords_.$keywordId'
import { Route as AuthOrgIdMarketingReviewsRepliesRouteImport } from './routes/_auth/$orgId/marketing/reviews_.replies'
import { Route as AuthOrgIdMarketingReferralsSetupRouteImport } from './routes/_auth/$orgId/marketing/referrals.setup'
import { Route as AuthOrgIdMarketingNewClientOfferSetupRouteImport } from './routes/_auth/$orgId/marketing/new-client-offer.setup'
import { Route as AuthOrgIdMarketingNewClientOfferGuestsRouteImport } from './routes/_auth/$orgId/marketing/new-client-offer.guests'
import { Route as AuthOrgIdMarketingGoogleRankingPhotosRouteImport } from './routes/_auth/$orgId/marketing/google-ranking_.photos'
import { Route as AuthOrgIdMarketingGoogleRankingProfileRouteImport } from './routes/_auth/$orgId/marketing/google-ranking.profile'
import { Route as AuthOrgIdMarketingGoogleRankingPostsRouteImport } from './routes/_auth/$orgId/marketing/google-ranking.posts'
import { Route as AuthOrgIdMarketingCreatorsCreatorIdRouteImport } from './routes/_auth/$orgId/marketing/creators_.$creatorId'
import { Route as AuthOrgIdMarketingCommentDmNewRouteImport } from './routes/_auth/$orgId/marketing/comment-dm_.new'
import { Route as AuthOrgIdMarketingCommentDmAutoReplyRouteImport } from './routes/_auth/$orgId/marketing/comment-dm_.auto-reply'
import { Route as AuthOrgIdMarketingCommentDmAutomationIdRouteImport } from './routes/_auth/$orgId/marketing/comment-dm_.$automationId'
import { Route as AuthOrgIdMarketingCampaignsNewRouteImport } from './routes/_auth/$orgId/marketing/campaigns_.new'
import { Route as AuthOrgIdMarketingCampaignsCampaignIdRouteImport } from './routes/_auth/$orgId/marketing/campaigns_.$campaignId'
import { Route as AuthOrgIdMarketingBulkSmsBulkSendIdRouteImport } from './routes/_auth/$orgId/marketing/bulk-sms_.$bulkSendId'
import { Route as AuthOrgIdMarketingCampaignsNewVoucherRouteImport } from './routes/_auth/$orgId/marketing/campaigns_.new_.voucher'
import { Route as AuthOrgIdMarketingCampaignsNewGiveawayRouteImport } from './routes/_auth/$orgId/marketing/campaigns_.new_.giveaway'
import { Route as AuthOrgIdMarketingCampaignsNewFlyerPageRouteImport } from './routes/_auth/$orgId/marketing/campaigns_.new_.flyer-page'
import { Route as AuthOrgIdMarketingCampaignsNewEventRouteImport } from './routes/_auth/$orgId/marketing/campaigns_.new_.event'
import { Route as AuthOrgIdMarketingCampaignsCampaignIdVoucherRouteImport } from './routes/_auth/$orgId/marketing/campaigns_.$campaignId_.voucher'
import { Route as AuthOrgIdMarketingCampaignsCampaignIdReviewRouteImport } from './routes/_auth/$orgId/marketing/campaigns_.$campaignId_.review'
import { Route as AuthOrgIdMarketingCampaignsCampaignIdPublishedRouteImport } from './routes/_auth/$orgId/marketing/campaigns_.$campaignId_.published'
import { Route as AuthOrgIdMarketingCampaignsCampaignIdLandingRouteImport } from './routes/_auth/$orgId/marketing/campaigns_.$campaignId_.landing'
import { Route as AuthOrgIdMarketingCampaignsCampaignIdGiveawayRouteImport } from './routes/_auth/$orgId/marketing/campaigns_.$campaignId_.giveaway'
import { Route as AuthOrgIdMarketingCampaignsCampaignIdAutomationsRouteImport } from './routes/_auth/$orgId/marketing/campaigns_.$campaignId_.automations'
import { Route as AuthOrgIdMarketingCampaignsCampaignIdGiveawayLiveRouteImport } from './routes/_auth/$orgId/marketing/campaigns_.$campaignId_.giveaway_.live'

const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DevRoute = DevRouteImport.update({
  id: '/_dev',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthGuidanceRoute = AuthGuidanceRouteImport.update({
  id: '/guidance',
  path: '/guidance',
  getParentRoute: () => AuthRoute,
} as any)
const AuthChooseSalonRoute = AuthChooseSalonRouteImport.update({
  id: '/choose-salon',
  path: '/choose-salon',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAgencyRoute = AuthAgencyRouteImport.update({
  id: '/agency',
  path: '/agency',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOrgIdRoute = AuthOrgIdRouteImport.update({
  id: '/$orgId',
  path: '/$orgId',
  getParentRoute: () => AuthRoute,
} as any)
const DevUiPreviewIndexRoute = DevUiPreviewIndexRouteImport.update({
  id: '/ui-preview/',
  path: '/ui-preview/',
  getParentRoute: () => DevRoute,
} as any)
const AuthAgencyIndexRoute = AuthAgencyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAgencyRoute,
} as any)
const AuthOrgIdIndexRoute = AuthOrgIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthOrgIdRoute,
} as any)
const DevUiPreviewInputsRoute = DevUiPreviewInputsRouteImport.update({
  id: '/ui-preview/inputs',
  path: '/ui-preview/inputs',
  getParentRoute: () => DevRoute,
} as any)
const AuthGoogleBusinessCallbackRoute =
  AuthGoogleBusinessCallbackRouteImport.update({
    id: '/google-business/callback',
    path: '/google-business/callback',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAgencyWebsiteRoute = AuthAgencyWebsiteRouteImport.update({
  id: '/website',
  path: '/website',
  getParentRoute: () => AuthAgencyRoute,
} as any)
const AuthAgencySocialResultsRoute = AuthAgencySocialResultsRouteImport.update({
  id: '/social-results',
  path: '/social-results',
  getParentRoute: () => AuthAgencyRoute,
} as any)
const AuthAgencySalonResultsRoute = AuthAgencySalonResultsRouteImport.update({
  id: '/salon-results',
  path: '/salon-results',
  getParentRoute: () => AuthAgencyRoute,
} as any)
const AuthAgencyRevenueCostsRoute = AuthAgencyRevenueCostsRouteImport.update({
  id: '/revenue-costs',
  path: '/revenue-costs',
  getParentRoute: () => AuthAgencyRoute,
} as any)
const AuthAgencyProfileRoute = AuthAgencyProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthAgencyRoute,
} as any)
const AuthAgencyMetaAdsRoute = AuthAgencyMetaAdsRouteImport.update({
  id: '/meta-ads',
  path: '/meta-ads',
  getParentRoute: () => AuthAgencyRoute,
} as any)
const AuthAgencyMembersRoute = AuthAgencyMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AuthAgencyRoute,
} as any)
const AuthAgencyGoogleRankingRoute = AuthAgencyGoogleRankingRouteImport.update({
  id: '/google-ranking',
  path: '/google-ranking',
  getParentRoute: () => AuthAgencyRoute,
} as any)
const AuthAgencyGoogleAdsRoute = AuthAgencyGoogleAdsRouteImport.update({
  id: '/google-ads',
  path: '/google-ads',
  getParentRoute: () => AuthAgencyRoute,
} as any)
const AuthAgencyEinRoute = AuthAgencyEinRouteImport.update({
  id: '/ein',
  path: '/ein',
  getParentRoute: () => AuthAgencyRoute,
} as any)
const AuthAgencyDemoRequestsRoute = AuthAgencyDemoRequestsRouteImport.update({
  id: '/demo-requests',
  path: '/demo-requests',
  getParentRoute: () => AuthAgencyRoute,
} as any)
const AuthOrgIdUserSettingsRoute = AuthOrgIdUserSettingsRouteImport.update({
  id: '/user-settings',
  path: '/user-settings',
  getParentRoute: () => AuthOrgIdRoute,
} as any)
const AuthOrgIdTurnTrackerRoute = AuthOrgIdTurnTrackerRouteImport.update({
  id: '/turn-tracker',
  path: '/turn-tracker',
  getParentRoute: () => AuthOrgIdRoute,
} as any)
const AuthOrgIdSalesRoute = AuthOrgIdSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => AuthOrgIdRoute,
} as any)
const AuthOrgIdReportsRoute = AuthOrgIdReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthOrgIdRoute,
} as any)
const AuthOrgIdProductsRoute = AuthOrgIdProductsRouteImport.update({
  id: '/products',
  path: '/products',
  getParentRoute: () => AuthOrgIdRoute,
} as any)
const AuthOrgIdMarketingRoute = AuthOrgIdMarketingRouteImport.update({
  id: '/marketing',
  path: '/marketing',
  getParentRoute: () => AuthOrgIdRoute,
} as any)
const AuthOrgIdInboxRoute = AuthOrgIdInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthOrgIdRoute,
} as any)
const AuthOrgIdGiftCardsRoute = AuthOrgIdGiftCardsRouteImport.update({
  id: '/gift-cards',
  path: '/gift-cards',
  getParentRoute: () => AuthOrgIdRoute,
} as any)
const AuthOrgIdGetStartedRoute = AuthOrgIdGetStartedRouteImport.update({
  id: '/get-started',
  path: '/get-started',
  getParentRoute: () => AuthOrgIdRoute,
} as any)
const AuthOrgIdClientsRoute = AuthOrgIdClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AuthOrgIdRoute,
} as any)
const AuthOrgIdCalendarRoute = AuthOrgIdCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AuthOrgIdRoute,
} as any)
const AuthOrgIdBioPageRoute = AuthOrgIdBioPageRouteImport.update({
  id: '/bio-page',
  path: '/bio-page',
  getParentRoute: () => AuthOrgIdRoute,
} as any)
const AuthAgencySalonsIndexRoute = AuthAgencySalonsIndexRouteImport.update({
  id: '/salons/',
  path: '/salons/',
  getParentRoute: () => AuthAgencyRoute,
} as any)
const AuthAgencyMembersIndexRoute = AuthAgencyMembersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAgencyMembersRoute,
} as any)
const AuthAgencyGuidanceIndexRoute = AuthAgencyGuidanceIndexRouteImport.update({
  id: '/guidance/',
  path: '/guidance/',
  getParentRoute: () => AuthAgencyRoute,
} as any)
const AuthAgencyGoogleBusinessIndexRoute =
  AuthAgencyGoogleBusinessIndexRouteImport.update({
    id: '/google-business/',
    path: '/google-business/',
    getParentRoute: () => AuthAgencyRoute,
  } as any)
const AuthAgencyAdsDoctorIndexRoute =
  AuthAgencyAdsDoctorIndexRouteImport.update({
    id: '/ads-doctor/',
    path: '/ads-doctor/',
    getParentRoute: () => AuthAgencyRoute,
  } as any)
const AuthOrgIdSettingsIndexRoute = AuthOrgIdSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AuthOrgIdRoute,
} as any)
const AuthOrgIdReportsIndexRoute = AuthOrgIdReportsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthOrgIdReportsRoute,
} as any)
const AuthOrgIdMarketingIndexRoute = AuthOrgIdMarketingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthOrgIdMarketingRoute,
} as any)
const AuthMetaCommentToDmCallbackRoute =
  AuthMetaCommentToDmCallbackRouteImport.update({
    id: '/meta/comment-to-dm/callback',
    path: '/meta/comment-to-dm/callback',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAgencySalonsNewRoute = AuthAgencySalonsNewRouteImport.update({
  id: '/salons/new',
  path: '/salons/new',
  getParentRoute: () => AuthAgencyRoute,
} as any)
const AuthAgencySalonsShortCodeRoute =
  AuthAgencySalonsShortCodeRouteImport.update({
    id: '/salons/$shortCode',
    path: '/salons/$shortCode',
    getParentRoute: () => AuthAgencyRoute,
  } as any)
const AuthAgencyMembersNewRoute = AuthAgencyMembersNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthAgencyMembersRoute,
} as any)
const AuthAgencyMembersMemberIdRoute =
  AuthAgencyMembersMemberIdRouteImport.update({
    id: '/$memberId',
    path: '/$memberId',
    getParentRoute: () => AuthAgencyMembersRoute,
  } as any)
const AuthAgencyGuidanceSlugRoute = AuthAgencyGuidanceSlugRouteImport.update({
  id: '/guidance/$slug',
  path: '/guidance/$slug',
  getParentRoute: () => AuthAgencyRoute,
} as any)
const AuthAgencyCounterStandsProgramRoute =
  AuthAgencyCounterStandsProgramRouteImport.update({
    id: '/counter-stands/program',
    path: '/counter-stands/program',
    getParentRoute: () => AuthAgencyRoute,
  } as any)
const AuthAgencyAdsDoctorAskRoute = AuthAgencyAdsDoctorAskRouteImport.update({
  id: '/ads-doctor/ask',
  path: '/ads-doctor/ask',
  getParentRoute: () => AuthAgencyRoute,
} as any)
const AuthAgencyAdsDoctorShortCodeRoute =
  AuthAgencyAdsDoctorShortCodeRouteImport.update({
    id: '/ads-doctor/$shortCode',
    path: '/ads-doctor/$shortCode',
    getParentRoute: () => AuthAgencyRoute,
  } as any)
const AuthOrgIdSettingsTurnTrackerRoute =
  AuthOrgIdSettingsTurnTrackerRouteImport.update({
    id: '/settings/turn-tracker',
    path: '/settings/turn-tracker',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsStaffRoute = AuthOrgIdSettingsStaffRouteImport.update({
  id: '/settings/staff',
  path: '/settings/staff',
  getParentRoute: () => AuthOrgIdRoute,
} as any)
const AuthOrgIdSettingsServicesRoute =
  AuthOrgIdSettingsServicesRouteImport.update({
    id: '/settings/services',
    path: '/settings/services',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsPlanAndUsageRoute =
  AuthOrgIdSettingsPlanAndUsageRouteImport.update({
    id: '/settings/plan-and-usage',
    path: '/settings/plan-and-usage',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsMarketingAccessRoute =
  AuthOrgIdSettingsMarketingAccessRouteImport.update({
    id: '/settings/marketing-access',
    path: '/settings/marketing-access',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsLinkInBioRoute =
  AuthOrgIdSettingsLinkInBioRouteImport.update({
    id: '/settings/link-in-bio',
    path: '/settings/link-in-bio',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsIntegrationsRoute =
  AuthOrgIdSettingsIntegrationsRouteImport.update({
    id: '/settings/integrations',
    path: '/settings/integrations',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsCheckInRoute =
  AuthOrgIdSettingsCheckInRouteImport.update({
    id: '/settings/check-in',
    path: '/settings/check-in',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsCallsRoute = AuthOrgIdSettingsCallsRouteImport.update({
  id: '/settings/calls',
  path: '/settings/calls',
  getParentRoute: () => AuthOrgIdRoute,
} as any)
const AuthOrgIdSettingsAppearanceRoute =
  AuthOrgIdSettingsAppearanceRouteImport.update({
    id: '/settings/appearance',
    path: '/settings/appearance',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdReportsTodayRoute = AuthOrgIdReportsTodayRouteImport.update({
  id: '/today',
  path: '/today',
  getParentRoute: () => AuthOrgIdReportsRoute,
} as any)
const AuthOrgIdReportsTeamRoute = AuthOrgIdReportsTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AuthOrgIdReportsRoute,
} as any)
const AuthOrgIdReportsSalesRoute = AuthOrgIdReportsSalesRouteImport.update({
  id: '/sales',
  path: '/sales',
  getParentRoute: () => AuthOrgIdReportsRoute,
} as any)
const AuthOrgIdReportsReviewsRoute = AuthOrgIdReportsReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => AuthOrgIdReportsRoute,
} as any)
const AuthOrgIdReportsMarketingRoute =
  AuthOrgIdReportsMarketingRouteImport.update({
    id: '/marketing',
    path: '/marketing',
    getParentRoute: () => AuthOrgIdReportsRoute,
  } as any)
const AuthOrgIdReportsImpactRoute = AuthOrgIdReportsImpactRouteImport.update({
  id: '/impact',
  path: '/impact',
  getParentRoute: () => AuthOrgIdReportsRoute,
} as any)
const AuthOrgIdReportsClientsRoute = AuthOrgIdReportsClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AuthOrgIdReportsRoute,
} as any)
const AuthOrgIdReportsAppointmentsRoute =
  AuthOrgIdReportsAppointmentsRouteImport.update({
    id: '/appointments',
    path: '/appointments',
    getParentRoute: () => AuthOrgIdReportsRoute,
  } as any)
const AuthOrgIdMarketingTextKeywordsRoute =
  AuthOrgIdMarketingTextKeywordsRouteImport.update({
    id: '/text-keywords',
    path: '/text-keywords',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingSettingsRoute =
  AuthOrgIdMarketingSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingRewardsCardRoute =
  AuthOrgIdMarketingRewardsCardRouteImport.update({
    id: '/rewards-card',
    path: '/rewards-card',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingReviewsRoute =
  AuthOrgIdMarketingReviewsRouteImport.update({
    id: '/reviews',
    path: '/reviews',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingReferralsRoute =
  AuthOrgIdMarketingReferralsRouteImport.update({
    id: '/referrals',
    path: '/referrals',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingQrCodesRoute =
  AuthOrgIdMarketingQrCodesRouteImport.update({
    id: '/qr-codes',
    path: '/qr-codes',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingPrizesRoute =
  AuthOrgIdMarketingPrizesRouteImport.update({
    id: '/prizes',
    path: '/prizes',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingOwnerReportRoute =
  AuthOrgIdMarketingOwnerReportRouteImport.update({
    id: '/owner-report',
    path: '/owner-report',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingNewClientOfferRoute =
  AuthOrgIdMarketingNewClientOfferRouteImport.update({
    id: '/new-client-offer',
    path: '/new-client-offer',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingListingsRoute =
  AuthOrgIdMarketingListingsRouteImport.update({
    id: '/listings',
    path: '/listings',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingLeadsRoute = AuthOrgIdMarketingLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AuthOrgIdMarketingRoute,
} as any)
const AuthOrgIdMarketingHayvenTapRoute =
  AuthOrgIdMarketingHayvenTapRouteImport.update({
    id: '/hayven-tap',
    path: '/hayven-tap',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingGoogleRankingRoute =
  AuthOrgIdMarketingGoogleRankingRouteImport.update({
    id: '/google-ranking',
    path: '/google-ranking',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingCreatorsRoute =
  AuthOrgIdMarketingCreatorsRouteImport.update({
    id: '/creators',
    path: '/creators',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingCommentDmRoute =
  AuthOrgIdMarketingCommentDmRouteImport.update({
    id: '/comment-dm',
    path: '/comment-dm',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingCampaignsRoute =
  AuthOrgIdMarketingCampaignsRouteImport.update({
    id: '/campaigns',
    path: '/campaigns',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingBulkSmsRoute =
  AuthOrgIdMarketingBulkSmsRouteImport.update({
    id: '/bulk-sms',
    path: '/bulk-sms',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingBioPageRoute =
  AuthOrgIdMarketingBioPageRouteImport.update({
    id: '/bio-page',
    path: '/bio-page',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingAnalyticsRoute =
  AuthOrgIdMarketingAnalyticsRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdGiftCardsSettingsRoute =
  AuthOrgIdGiftCardsSettingsRouteImport.update({
    id: '/gift-cards_/settings',
    path: '/gift-cards/settings',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdMarketingReferralsIndexRoute =
  AuthOrgIdMarketingReferralsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOrgIdMarketingReferralsRoute,
  } as any)
const AuthOrgIdMarketingNewClientOfferIndexRoute =
  AuthOrgIdMarketingNewClientOfferIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOrgIdMarketingNewClientOfferRoute,
  } as any)
const AuthOrgIdMarketingGoogleRankingIndexRoute =
  AuthOrgIdMarketingGoogleRankingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthOrgIdMarketingGoogleRankingRoute,
  } as any)
const AuthOrgIdSettingsServicesSameTimeRoute =
  AuthOrgIdSettingsServicesSameTimeRouteImport.update({
    id: '/settings/services_/same-time',
    path: '/settings/services/same-time',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsServicesImportRoute =
  AuthOrgIdSettingsServicesImportRouteImport.update({
    id: '/settings/services_/import',
    path: '/settings/services/import',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsOnlineBookingStaffSelectionRoute =
  AuthOrgIdSettingsOnlineBookingStaffSelectionRouteImport.update({
    id: '/settings/online-booking/staff-selection',
    path: '/settings/online-booking/staff-selection',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsOnlineBookingSetupIntegrationRoute =
  AuthOrgIdSettingsOnlineBookingSetupIntegrationRouteImport.update({
    id: '/settings/online-booking/setup-integration',
    path: '/settings/online-booking/setup-integration',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsOnlineBookingPreferencesRoute =
  AuthOrgIdSettingsOnlineBookingPreferencesRouteImport.update({
    id: '/settings/online-booking/preferences',
    path: '/settings/online-booking/preferences',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsCalendarAppointmentsSchedulingOptionsRoute =
  AuthOrgIdSettingsCalendarAppointmentsSchedulingOptionsRouteImport.update({
    id: '/settings/calendar-appointments/scheduling-options',
    path: '/settings/calendar-appointments/scheduling-options',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsCalendarAppointmentsNoShowProtectionRoute =
  AuthOrgIdSettingsCalendarAppointmentsNoShowProtectionRouteImport.update({
    id: '/settings/calendar-appointments/no-show-protection',
    path: '/settings/calendar-appointments/no-show-protection',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsCalendarAppointmentsDisplayPreferencesRoute =
  AuthOrgIdSettingsCalendarAppointmentsDisplayPreferencesRouteImport.update({
    id: '/settings/calendar-appointments/display-preferences',
    path: '/settings/calendar-appointments/display-preferences',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsCalendarAppointmentsCancelRescheduleRoute =
  AuthOrgIdSettingsCalendarAppointmentsCancelRescheduleRouteImport.update({
    id: '/settings/calendar-appointments/cancel-reschedule',
    path: '/settings/calendar-appointments/cancel-reschedule',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsBusinessSetupPhoneNumbersRoute =
  AuthOrgIdSettingsBusinessSetupPhoneNumbersRouteImport.update({
    id: '/settings/business-setup/phone-numbers',
    path: '/settings/business-setup/phone-numbers',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsBusinessSetupPayrollRoute =
  AuthOrgIdSettingsBusinessSetupPayrollRouteImport.update({
    id: '/settings/business-setup/payroll',
    path: '/settings/business-setup/payroll',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsBusinessSetupLogoBrandingRoute =
  AuthOrgIdSettingsBusinessSetupLogoBrandingRouteImport.update({
    id: '/settings/business-setup/logo-branding',
    path: '/settings/business-setup/logo-branding',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsBusinessSetupLocationsRoute =
  AuthOrgIdSettingsBusinessSetupLocationsRouteImport.update({
    id: '/settings/business-setup/locations',
    path: '/settings/business-setup/locations',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsBusinessSetupHowYouUseHayvenRoute =
  AuthOrgIdSettingsBusinessSetupHowYouUseHayvenRouteImport.update({
    id: '/settings/business-setup/how-you-use-hayven',
    path: '/settings/business-setup/how-you-use-hayven',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsBusinessSetupBusinessHoursRoute =
  AuthOrgIdSettingsBusinessSetupBusinessHoursRouteImport.update({
    id: '/settings/business-setup/business-hours',
    path: '/settings/business-setup/business-hours',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsBusinessSetupBusinessDetailsRoute =
  AuthOrgIdSettingsBusinessSetupBusinessDetailsRouteImport.update({
    id: '/settings/business-setup/business-details',
    path: '/settings/business-setup/business-details',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsBusinessSetupAdvancedSettingsRoute =
  AuthOrgIdSettingsBusinessSetupAdvancedSettingsRouteImport.update({
    id: '/settings/business-setup/advanced-settings',
    path: '/settings/business-setup/advanced-settings',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsAutomatedMessagesGiftCardsRoute =
  AuthOrgIdSettingsAutomatedMessagesGiftCardsRouteImport.update({
    id: '/settings/automated-messages/gift-cards',
    path: '/settings/automated-messages/gift-cards',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsAutomatedMessagesCheckInProcessRoute =
  AuthOrgIdSettingsAutomatedMessagesCheckInProcessRouteImport.update({
    id: '/settings/automated-messages/check-in-process',
    path: '/settings/automated-messages/check-in-process',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsAutomatedMessagesAppointmentRescheduledRoute =
  AuthOrgIdSettingsAutomatedMessagesAppointmentRescheduledRouteImport.update({
    id: '/settings/automated-messages/appointment-rescheduled',
    path: '/settings/automated-messages/appointment-rescheduled',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsAutomatedMessagesAppointmentCompletedRoute =
  AuthOrgIdSettingsAutomatedMessagesAppointmentCompletedRouteImport.update({
    id: '/settings/automated-messages/appointment-completed',
    path: '/settings/automated-messages/appointment-completed',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsAutomatedMessagesAppointmentCancelledRoute =
  AuthOrgIdSettingsAutomatedMessagesAppointmentCancelledRouteImport.update({
    id: '/settings/automated-messages/appointment-cancelled',
    path: '/settings/automated-messages/appointment-cancelled',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdSettingsAutomatedMessagesAppointmentBookedRoute =
  AuthOrgIdSettingsAutomatedMessagesAppointmentBookedRouteImport.update({
    id: '/settings/automated-messages/appointment-booked',
    path: '/settings/automated-messages/appointment-booked',
    getParentRoute: () => AuthOrgIdRoute,
  } as any)
const AuthOrgIdMarketingTextKeywordsKeywordIdRoute =
  AuthOrgIdMarketingTextKeywordsKeywordIdRouteImport.update({
    id: '/text-keywords_/$keywordId',
    path: '/text-keywords/$keywordId',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingReviewsRepliesRoute =
  AuthOrgIdMarketingReviewsRepliesRouteImport.update({
    id: '/reviews_/replies',
    path: '/reviews/replies',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingReferralsSetupRoute =
  AuthOrgIdMarketingReferralsSetupRouteImport.update({
    id: '/setup',
    path: '/setup',
    getParentRoute: () => AuthOrgIdMarketingReferralsRoute,
  } as any)
const AuthOrgIdMarketingNewClientOfferSetupRoute =
  AuthOrgIdMarketingNewClientOfferSetupRouteImport.update({
    id: '/setup',
    path: '/setup',
    getParentRoute: () => AuthOrgIdMarketingNewClientOfferRoute,
  } as any)
const AuthOrgIdMarketingNewClientOfferGuestsRoute =
  AuthOrgIdMarketingNewClientOfferGuestsRouteImport.update({
    id: '/guests',
    path: '/guests',
    getParentRoute: () => AuthOrgIdMarketingNewClientOfferRoute,
  } as any)
const AuthOrgIdMarketingGoogleRankingPhotosRoute =
  AuthOrgIdMarketingGoogleRankingPhotosRouteImport.update({
    id: '/google-ranking_/photos',
    path: '/google-ranking/photos',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingGoogleRankingProfileRoute =
  AuthOrgIdMarketingGoogleRankingProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthOrgIdMarketingGoogleRankingRoute,
  } as any)
const AuthOrgIdMarketingGoogleRankingPostsRoute =
  AuthOrgIdMarketingGoogleRankingPostsRouteImport.update({
    id: '/posts',
    path: '/posts',
    getParentRoute: () => AuthOrgIdMarketingGoogleRankingRoute,
  } as any)
const AuthOrgIdMarketingCreatorsCreatorIdRoute =
  AuthOrgIdMarketingCreatorsCreatorIdRouteImport.update({
    id: '/creators_/$creatorId',
    path: '/creators/$creatorId',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingCommentDmNewRoute =
  AuthOrgIdMarketingCommentDmNewRouteImport.update({
    id: '/comment-dm_/new',
    path: '/comment-dm/new',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingCommentDmAutoReplyRoute =
  AuthOrgIdMarketingCommentDmAutoReplyRouteImport.update({
    id: '/comment-dm_/auto-reply',
    path: '/comment-dm/auto-reply',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingCommentDmAutomationIdRoute =
  AuthOrgIdMarketingCommentDmAutomationIdRouteImport.update({
    id: '/comment-dm_/$automationId',
    path: '/comment-dm/$automationId',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingCampaignsNewRoute =
  AuthOrgIdMarketingCampaignsNewRouteImport.update({
    id: '/campaigns_/new',
    path: '/campaigns/new',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingCampaignsCampaignIdRoute =
  AuthOrgIdMarketingCampaignsCampaignIdRouteImport.update({
    id: '/campaigns_/$campaignId',
    path: '/campaigns/$campaignId',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingBulkSmsBulkSendIdRoute =
  AuthOrgIdMarketingBulkSmsBulkSendIdRouteImport.update({
    id: '/bulk-sms_/$bulkSendId',
    path: '/bulk-sms/$bulkSendId',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingCampaignsNewVoucherRoute =
  AuthOrgIdMarketingCampaignsNewVoucherRouteImport.update({
    id: '/campaigns_/new_/voucher',
    path: '/campaigns/new/voucher',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingCampaignsNewGiveawayRoute =
  AuthOrgIdMarketingCampaignsNewGiveawayRouteImport.update({
    id: '/campaigns_/new_/giveaway',
    path: '/campaigns/new/giveaway',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingCampaignsNewFlyerPageRoute =
  AuthOrgIdMarketingCampaignsNewFlyerPageRouteImport.update({
    id: '/campaigns_/new_/flyer-page',
    path: '/campaigns/new/flyer-page',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingCampaignsNewEventRoute =
  AuthOrgIdMarketingCampaignsNewEventRouteImport.update({
    id: '/campaigns_/new_/event',
    path: '/campaigns/new/event',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingCampaignsCampaignIdVoucherRoute =
  AuthOrgIdMarketingCampaignsCampaignIdVoucherRouteImport.update({
    id: '/campaigns_/$campaignId_/voucher',
    path: '/campaigns/$campaignId/voucher',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingCampaignsCampaignIdReviewRoute =
  AuthOrgIdMarketingCampaignsCampaignIdReviewRouteImport.update({
    id: '/campaigns_/$campaignId_/review',
    path: '/campaigns/$campaignId/review',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingCampaignsCampaignIdPublishedRoute =
  AuthOrgIdMarketingCampaignsCampaignIdPublishedRouteImport.update({
    id: '/campaigns_/$campaignId_/published',
    path: '/campaigns/$campaignId/published',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingCampaignsCampaignIdLandingRoute =
  AuthOrgIdMarketingCampaignsCampaignIdLandingRouteImport.update({
    id: '/campaigns_/$campaignId_/landing',
    path: '/campaigns/$campaignId/landing',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingCampaignsCampaignIdGiveawayRoute =
  AuthOrgIdMarketingCampaignsCampaignIdGiveawayRouteImport.update({
    id: '/campaigns_/$campaignId_/giveaway',
    path: '/campaigns/$campaignId/giveaway',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingCampaignsCampaignIdAutomationsRoute =
  AuthOrgIdMarketingCampaignsCampaignIdAutomationsRouteImport.update({
    id: '/campaigns_/$campaignId_/automations',
    path: '/campaigns/$campaignId/automations',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)
const AuthOrgIdMarketingCampaignsCampaignIdGiveawayLiveRoute =
  AuthOrgIdMarketingCampaignsCampaignIdGiveawayLiveRouteImport.update({
    id: '/campaigns_/$campaignId_/giveaway_/live',
    path: '/campaigns/$campaignId/giveaway/live',
    getParentRoute: () => AuthOrgIdMarketingRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/$orgId': typeof AuthOrgIdRouteWithChildren
  '/agency': typeof AuthAgencyRouteWithChildren
  '/choose-salon': typeof AuthChooseSalonRoute
  '/guidance': typeof AuthGuidanceRoute
  '/$orgId/bio-page': typeof AuthOrgIdBioPageRoute
  '/$orgId/calendar': typeof AuthOrgIdCalendarRoute
  '/$orgId/clients': typeof AuthOrgIdClientsRoute
  '/$orgId/get-started': typeof AuthOrgIdGetStartedRoute
  '/$orgId/gift-cards': typeof AuthOrgIdGiftCardsRoute
  '/$orgId/inbox': typeof AuthOrgIdInboxRoute
  '/$orgId/marketing': typeof AuthOrgIdMarketingRouteWithChildren
  '/$orgId/products': typeof AuthOrgIdProductsRoute
  '/$orgId/reports': typeof AuthOrgIdReportsRouteWithChildren
  '/$orgId/sales': typeof AuthOrgIdSalesRoute
  '/$orgId/turn-tracker': typeof AuthOrgIdTurnTrackerRoute
  '/$orgId/user-settings': typeof AuthOrgIdUserSettingsRoute
  '/agency/demo-requests': typeof AuthAgencyDemoRequestsRoute
  '/agency/ein': typeof AuthAgencyEinRoute
  '/agency/google-ads': typeof AuthAgencyGoogleAdsRoute
  '/agency/google-ranking': typeof AuthAgencyGoogleRankingRoute
  '/agency/members': typeof AuthAgencyMembersRouteWithChildren
  '/agency/meta-ads': typeof AuthAgencyMetaAdsRoute
  '/agency/profile': typeof AuthAgencyProfileRoute
  '/agency/revenue-costs': typeof AuthAgencyRevenueCostsRoute
  '/agency/salon-results': typeof AuthAgencySalonResultsRoute
  '/agency/social-results': typeof AuthAgencySocialResultsRoute
  '/agency/website': typeof AuthAgencyWebsiteRoute
  '/google-business/callback': typeof AuthGoogleBusinessCallbackRoute
  '/ui-preview/inputs': typeof DevUiPreviewInputsRoute
  '/$orgId/': typeof AuthOrgIdIndexRoute
  '/agency/': typeof AuthAgencyIndexRoute
  '/ui-preview': typeof DevUiPreviewIndexRoute
  '/$orgId/gift-cards/settings': typeof AuthOrgIdGiftCardsSettingsRoute
  '/$orgId/marketing/analytics': typeof AuthOrgIdMarketingAnalyticsRoute
  '/$orgId/marketing/bio-page': typeof AuthOrgIdMarketingBioPageRoute
  '/$orgId/marketing/bulk-sms': typeof AuthOrgIdMarketingBulkSmsRoute
  '/$orgId/marketing/campaigns': typeof AuthOrgIdMarketingCampaignsRoute
  '/$orgId/marketing/comment-dm': typeof AuthOrgIdMarketingCommentDmRoute
  '/$orgId/marketing/creators': typeof AuthOrgIdMarketingCreatorsRoute
  '/$orgId/marketing/google-ranking': typeof AuthOrgIdMarketingGoogleRankingRouteWithChildren
  '/$orgId/marketing/hayven-tap': typeof AuthOrgIdMarketingHayvenTapRoute
  '/$orgId/marketing/leads': typeof AuthOrgIdMarketingLeadsRoute
  '/$orgId/marketing/listings': typeof AuthOrgIdMarketingListingsRoute
  '/$orgId/marketing/new-client-offer': typeof AuthOrgIdMarketingNewClientOfferRouteWithChildren
  '/$orgId/marketing/owner-report': typeof AuthOrgIdMarketingOwnerReportRoute
  '/$orgId/marketing/prizes': typeof AuthOrgIdMarketingPrizesRoute
  '/$orgId/marketing/qr-codes': typeof AuthOrgIdMarketingQrCodesRoute
  '/$orgId/marketing/referrals': typeof AuthOrgIdMarketingReferralsRouteWithChildren
  '/$orgId/marketing/reviews': typeof AuthOrgIdMarketingReviewsRoute
  '/$orgId/marketing/rewards-card': typeof AuthOrgIdMarketingRewardsCardRoute
  '/$orgId/marketing/settings': typeof AuthOrgIdMarketingSettingsRoute
  '/$orgId/marketing/text-keywords': typeof AuthOrgIdMarketingTextKeywordsRoute
  '/$orgId/reports/appointments': typeof AuthOrgIdReportsAppointmentsRoute
  '/$orgId/reports/clients': typeof AuthOrgIdReportsClientsRoute
  '/$orgId/reports/impact': typeof AuthOrgIdReportsImpactRoute
  '/$orgId/reports/marketing': typeof AuthOrgIdReportsMarketingRoute
  '/$orgId/reports/reviews': typeof AuthOrgIdReportsReviewsRoute
  '/$orgId/reports/sales': typeof AuthOrgIdReportsSalesRoute
  '/$orgId/reports/team': typeof AuthOrgIdReportsTeamRoute
  '/$orgId/reports/today': typeof AuthOrgIdReportsTodayRoute
  '/$orgId/settings/appearance': typeof AuthOrgIdSettingsAppearanceRoute
  '/$orgId/settings/calls': typeof AuthOrgIdSettingsCallsRoute
  '/$orgId/settings/check-in': typeof AuthOrgIdSettingsCheckInRoute
  '/$orgId/settings/integrations': typeof AuthOrgIdSettingsIntegrationsRoute
  '/$orgId/settings/link-in-bio': typeof AuthOrgIdSettingsLinkInBioRoute
  '/$orgId/settings/marketing-access': typeof AuthOrgIdSettingsMarketingAccessRoute
  '/$orgId/settings/plan-and-usage': typeof AuthOrgIdSettingsPlanAndUsageRoute
  '/$orgId/settings/services': typeof AuthOrgIdSettingsServicesRoute
  '/$orgId/settings/staff': typeof AuthOrgIdSettingsStaffRoute
  '/$orgId/settings/turn-tracker': typeof AuthOrgIdSettingsTurnTrackerRoute
  '/agency/ads-doctor/$shortCode': typeof AuthAgencyAdsDoctorShortCodeRoute
  '/agency/ads-doctor/ask': typeof AuthAgencyAdsDoctorAskRoute
  '/agency/counter-stands/program': typeof AuthAgencyCounterStandsProgramRoute
  '/agency/guidance/$slug': typeof AuthAgencyGuidanceSlugRoute
  '/agency/members/$memberId': typeof AuthAgencyMembersMemberIdRoute
  '/agency/members/new': typeof AuthAgencyMembersNewRoute
  '/agency/salons/$shortCode': typeof AuthAgencySalonsShortCodeRoute
  '/agency/salons/new': typeof AuthAgencySalonsNewRoute
  '/meta/comment-to-dm/callback': typeof AuthMetaCommentToDmCallbackRoute
  '/$orgId/marketing/': typeof AuthOrgIdMarketingIndexRoute
  '/$orgId/reports/': typeof AuthOrgIdReportsIndexRoute
  '/$orgId/settings': typeof AuthOrgIdSettingsIndexRoute
  '/agency/ads-doctor': typeof AuthAgencyAdsDoctorIndexRoute
  '/agency/google-business': typeof AuthAgencyGoogleBusinessIndexRoute
  '/agency/guidance': typeof AuthAgencyGuidanceIndexRoute
  '/agency/members/': typeof AuthAgencyMembersIndexRoute
  '/agency/salons': typeof AuthAgencySalonsIndexRoute
  '/$orgId/marketing/bulk-sms/$bulkSendId': typeof AuthOrgIdMarketingBulkSmsBulkSendIdRoute
  '/$orgId/marketing/campaigns/$campaignId': typeof AuthOrgIdMarketingCampaignsCampaignIdRoute
  '/$orgId/marketing/campaigns/new': typeof AuthOrgIdMarketingCampaignsNewRoute
  '/$orgId/marketing/comment-dm/$automationId': typeof AuthOrgIdMarketingCommentDmAutomationIdRoute
  '/$orgId/marketing/comment-dm/auto-reply': typeof AuthOrgIdMarketingCommentDmAutoReplyRoute
  '/$orgId/marketing/comment-dm/new': typeof AuthOrgIdMarketingCommentDmNewRoute
  '/$orgId/marketing/creators/$creatorId': typeof AuthOrgIdMarketingCreatorsCreatorIdRoute
  '/$orgId/marketing/google-ranking/posts': typeof AuthOrgIdMarketingGoogleRankingPostsRoute
  '/$orgId/marketing/google-ranking/profile': typeof AuthOrgIdMarketingGoogleRankingProfileRoute
  '/$orgId/marketing/google-ranking/photos': typeof AuthOrgIdMarketingGoogleRankingPhotosRoute
  '/$orgId/marketing/new-client-offer/guests': typeof AuthOrgIdMarketingNewClientOfferGuestsRoute
  '/$orgId/marketing/new-client-offer/setup': typeof AuthOrgIdMarketingNewClientOfferSetupRoute
  '/$orgId/marketing/referrals/setup': typeof AuthOrgIdMarketingReferralsSetupRoute
  '/$orgId/marketing/reviews/replies': typeof AuthOrgIdMarketingReviewsRepliesRoute
  '/$orgId/marketing/text-keywords/$keywordId': typeof AuthOrgIdMarketingTextKeywordsKeywordIdRoute
  '/$orgId/settings/automated-messages/appointment-booked': typeof AuthOrgIdSettingsAutomatedMessagesAppointmentBookedRoute
  '/$orgId/settings/automated-messages/appointment-cancelled': typeof AuthOrgIdSettingsAutomatedMessagesAppointmentCancelledRoute
  '/$orgId/settings/automated-messages/appointment-completed': typeof AuthOrgIdSettingsAutomatedMessagesAppointmentCompletedRoute
  '/$orgId/settings/automated-messages/appointment-rescheduled': typeof AuthOrgIdSettingsAutomatedMessagesAppointmentRescheduledRoute
  '/$orgId/settings/automated-messages/check-in-process': typeof AuthOrgIdSettingsAutomatedMessagesCheckInProcessRoute
  '/$orgId/settings/automated-messages/gift-cards': typeof AuthOrgIdSettingsAutomatedMessagesGiftCardsRoute
  '/$orgId/settings/business-setup/advanced-settings': typeof AuthOrgIdSettingsBusinessSetupAdvancedSettingsRoute
  '/$orgId/settings/business-setup/business-details': typeof AuthOrgIdSettingsBusinessSetupBusinessDetailsRoute
  '/$orgId/settings/business-setup/business-hours': typeof AuthOrgIdSettingsBusinessSetupBusinessHoursRoute
  '/$orgId/settings/business-setup/how-you-use-hayven': typeof AuthOrgIdSettingsBusinessSetupHowYouUseHayvenRoute
  '/$orgId/settings/business-setup/locations': typeof AuthOrgIdSettingsBusinessSetupLocationsRoute
  '/$orgId/settings/business-setup/logo-branding': typeof AuthOrgIdSettingsBusinessSetupLogoBrandingRoute
  '/$orgId/settings/business-setup/payroll': typeof AuthOrgIdSettingsBusinessSetupPayrollRoute
  '/$orgId/settings/business-setup/phone-numbers': typeof AuthOrgIdSettingsBusinessSetupPhoneNumbersRoute
  '/$orgId/settings/calendar-appointments/cancel-reschedule': typeof AuthOrgIdSettingsCalendarAppointmentsCancelRescheduleRoute
  '/$orgId/settings/calendar-appointments/display-preferences': typeof AuthOrgIdSettingsCalendarAppointmentsDisplayPreferencesRoute
  '/$orgId/settings/calendar-appointments/no-show-protection': typeof AuthOrgIdSettingsCalendarAppointmentsNoShowProtectionRoute
  '/$orgId/settings/calendar-appointments/scheduling-options': typeof AuthOrgIdSettingsCalendarAppointmentsSchedulingOptionsRoute
  '/$orgId/settings/online-booking/preferences': typeof AuthOrgIdSettingsOnlineBookingPreferencesRoute
  '/$orgId/settings/online-booking/setup-integration': typeof AuthOrgIdSettingsOnlineBookingSetupIntegrationRoute
  '/$orgId/settings/online-booking/staff-selection': typeof AuthOrgIdSettingsOnlineBookingStaffSelectionRoute
  '/$orgId/settings/services/import': typeof AuthOrgIdSettingsServicesImportRoute
  '/$orgId/settings/services/same-time': typeof AuthOrgIdSettingsServicesSameTimeRoute
  '/$orgId/marketing/google-ranking/': typeof AuthOrgIdMarketingGoogleRankingIndexRoute
  '/$orgId/marketing/new-client-offer/': typeof AuthOrgIdMarketingNewClientOfferIndexRoute
  '/$orgId/marketing/referrals/': typeof AuthOrgIdMarketingReferralsIndexRoute
  '/$orgId/marketing/campaigns/$campaignId/automations': typeof AuthOrgIdMarketingCampaignsCampaignIdAutomationsRoute
  '/$orgId/marketing/campaigns/$campaignId/giveaway': typeof AuthOrgIdMarketingCampaignsCampaignIdGiveawayRoute
  '/$orgId/marketing/campaigns/$campaignId/landing': typeof AuthOrgIdMarketingCampaignsCampaignIdLandingRoute
  '/$orgId/marketing/campaigns/$campaignId/published': typeof AuthOrgIdMarketingCampaignsCampaignIdPublishedRoute
  '/$orgId/marketing/campaigns/$campaignId/review': typeof AuthOrgIdMarketingCampaignsCampaignIdReviewRoute
  '/$orgId/marketing/campaigns/$campaignId/voucher': typeof AuthOrgIdMarketingCampaignsCampaignIdVoucherRoute
  '/$orgId/marketing/campaigns/new/event': typeof AuthOrgIdMarketingCampaignsNewEventRoute
  '/$orgId/marketing/campaigns/new/flyer-page': typeof AuthOrgIdMarketingCampaignsNewFlyerPageRoute
  '/$orgId/marketing/campaigns/new/giveaway': typeof AuthOrgIdMarketingCampaignsNewGiveawayRoute
  '/$orgId/marketing/campaigns/new/voucher': typeof AuthOrgIdMarketingCampaignsNewVoucherRoute
  '/$orgId/marketing/campaigns/$campaignId/giveaway/live': typeof AuthOrgIdMarketingCampaignsCampaignIdGiveawayLiveRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/choose-salon': typeof AuthChooseSalonRoute
  '/guidance': typeof AuthGuidanceRoute
  '/$orgId/bio-page': typeof AuthOrgIdBioPageRoute
  '/$orgId/calendar': typeof AuthOrgIdCalendarRoute
  '/$orgId/clients': typeof AuthOrgIdClientsRoute
  '/$orgId/get-started': typeof AuthOrgIdGetStartedRoute
  '/$orgId/gift-cards': typeof AuthOrgIdGiftCardsRoute
  '/$orgId/inbox': typeof AuthOrgIdInboxRoute
  '/$orgId/products': typeof AuthOrgIdProductsRoute
  '/$orgId/sales': typeof AuthOrgIdSalesRoute
  '/$orgId/turn-tracker': typeof AuthOrgIdTurnTrackerRoute
  '/$orgId/user-settings': typeof AuthOrgIdUserSettingsRoute
  '/agency/demo-requests': typeof AuthAgencyDemoRequestsRoute
  '/agency/ein': typeof AuthAgencyEinRoute
  '/agency/google-ads': typeof AuthAgencyGoogleAdsRoute
  '/agency/google-ranking': typeof AuthAgencyGoogleRankingRoute
  '/agency/meta-ads': typeof AuthAgencyMetaAdsRoute
  '/agency/profile': typeof AuthAgencyProfileRoute
  '/agency/revenue-costs': typeof AuthAgencyRevenueCostsRoute
  '/agency/salon-results': typeof AuthAgencySalonResultsRoute
  '/agency/social-results': typeof AuthAgencySocialResultsRoute
  '/agency/website': typeof AuthAgencyWebsiteRoute
  '/google-business/callback': typeof AuthGoogleBusinessCallbackRoute
  '/ui-preview/inputs': typeof DevUiPreviewInputsRoute
  '/$orgId': typeof AuthOrgIdIndexRoute
  '/agency': typeof AuthAgencyIndexRoute
  '/ui-preview': typeof DevUiPreviewIndexRoute
  '/$orgId/gift-cards/settings': typeof AuthOrgIdGiftCardsSettingsRoute
  '/$orgId/marketing/analytics': typeof AuthOrgIdMarketingAnalyticsRoute
  '/$orgId/marketing/bio-page': typeof AuthOrgIdMarketingBioPageRoute
  '/$orgId/marketing/bulk-sms': typeof AuthOrgIdMarketingBulkSmsRoute
  '/$orgId/marketing/campaigns': typeof AuthOrgIdMarketingCampaignsRoute
  '/$orgId/marketing/comment-dm': typeof AuthOrgIdMarketingCommentDmRoute
  '/$orgId/marketing/creators': typeof AuthOrgIdMarketingCreatorsRoute
  '/$orgId/marketing/hayven-tap': typeof AuthOrgIdMarketingHayvenTapRoute
  '/$orgId/marketing/leads': typeof AuthOrgIdMarketingLeadsRoute
  '/$orgId/marketing/listings': typeof AuthOrgIdMarketingListingsRoute
  '/$orgId/marketing/owner-report': typeof AuthOrgIdMarketingOwnerReportRoute
  '/$orgId/marketing/prizes': typeof AuthOrgIdMarketingPrizesRoute
  '/$orgId/marketing/qr-codes': typeof AuthOrgIdMarketingQrCodesRoute
  '/$orgId/marketing/reviews': typeof AuthOrgIdMarketingReviewsRoute
  '/$orgId/marketing/rewards-card': typeof AuthOrgIdMarketingRewardsCardRoute
  '/$orgId/marketing/settings': typeof AuthOrgIdMarketingSettingsRoute
  '/$orgId/marketing/text-keywords': typeof AuthOrgIdMarketingTextKeywordsRoute
  '/$orgId/reports/appointments': typeof AuthOrgIdReportsAppointmentsRoute
  '/$orgId/reports/clients': typeof AuthOrgIdReportsClientsRoute
  '/$orgId/reports/impact': typeof AuthOrgIdReportsImpactRoute
  '/$orgId/reports/marketing': typeof AuthOrgIdReportsMarketingRoute
  '/$orgId/reports/reviews': typeof AuthOrgIdReportsReviewsRoute
  '/$orgId/reports/sales': typeof AuthOrgIdReportsSalesRoute
  '/$orgId/reports/team': typeof AuthOrgIdReportsTeamRoute
  '/$orgId/reports/today': typeof AuthOrgIdReportsTodayRoute
  '/$orgId/settings/appearance': typeof AuthOrgIdSettingsAppearanceRoute
  '/$orgId/settings/calls': typeof AuthOrgIdSettingsCallsRoute
  '/$orgId/settings/check-in': typeof AuthOrgIdSettingsCheckInRoute
  '/$orgId/settings/integrations': typeof AuthOrgIdSettingsIntegrationsRoute
  '/$orgId/settings/link-in-bio': typeof AuthOrgIdSettingsLinkInBioRoute
  '/$orgId/settings/marketing-access': typeof AuthOrgIdSettingsMarketingAccessRoute
  '/$orgId/settings/plan-and-usage': typeof AuthOrgIdSettingsPlanAndUsageRoute
  '/$orgId/settings/services': typeof AuthOrgIdSettingsServicesRoute
  '/$orgId/settings/staff': typeof AuthOrgIdSettingsStaffRoute
  '/$orgId/settings/turn-tracker': typeof AuthOrgIdSettingsTurnTrackerRoute
  '/agency/ads-doctor/$shortCode': typeof AuthAgencyAdsDoctorShortCodeRoute
  '/agency/ads-doctor/ask': typeof AuthAgencyAdsDoctorAskRoute
  '/agency/counter-stands/program': typeof AuthAgencyCounterStandsProgramRoute
  '/agency/guidance/$slug': typeof AuthAgencyGuidanceSlugRoute
  '/agency/members/$memberId': typeof AuthAgencyMembersMemberIdRoute
  '/agency/members/new': typeof AuthAgencyMembersNewRoute
  '/agency/salons/$shortCode': typeof AuthAgencySalonsShortCodeRoute
  '/agency/salons/new': typeof AuthAgencySalonsNewRoute
  '/meta/comment-to-dm/callback': typeof AuthMetaCommentToDmCallbackRoute
  '/$orgId/marketing': typeof AuthOrgIdMarketingIndexRoute
  '/$orgId/reports': typeof AuthOrgIdReportsIndexRoute
  '/$orgId/settings': typeof AuthOrgIdSettingsIndexRoute
  '/agency/ads-doctor': typeof AuthAgencyAdsDoctorIndexRoute
  '/agency/google-business': typeof AuthAgencyGoogleBusinessIndexRoute
  '/agency/guidance': typeof AuthAgencyGuidanceIndexRoute
  '/agency/members': typeof AuthAgencyMembersIndexRoute
  '/agency/salons': typeof AuthAgencySalonsIndexRoute
  '/$orgId/marketing/bulk-sms/$bulkSendId': typeof AuthOrgIdMarketingBulkSmsBulkSendIdRoute
  '/$orgId/marketing/campaigns/$campaignId': typeof AuthOrgIdMarketingCampaignsCampaignIdRoute
  '/$orgId/marketing/campaigns/new': typeof AuthOrgIdMarketingCampaignsNewRoute
  '/$orgId/marketing/comment-dm/$automationId': typeof AuthOrgIdMarketingCommentDmAutomationIdRoute
  '/$orgId/marketing/comment-dm/auto-reply': typeof AuthOrgIdMarketingCommentDmAutoReplyRoute
  '/$orgId/marketing/comment-dm/new': typeof AuthOrgIdMarketingCommentDmNewRoute
  '/$orgId/marketing/creators/$creatorId': typeof AuthOrgIdMarketingCreatorsCreatorIdRoute
  '/$orgId/marketing/google-ranking/posts': typeof AuthOrgIdMarketingGoogleRankingPostsRoute
  '/$orgId/marketing/google-ranking/profile': typeof AuthOrgIdMarketingGoogleRankingProfileRoute
  '/$orgId/marketing/google-ranking/photos': typeof AuthOrgIdMarketingGoogleRankingPhotosRoute
  '/$orgId/marketing/new-client-offer/guests': typeof AuthOrgIdMarketingNewClientOfferGuestsRoute
  '/$orgId/marketing/new-client-offer/setup': typeof AuthOrgIdMarketingNewClientOfferSetupRoute
  '/$orgId/marketing/referrals/setup': typeof AuthOrgIdMarketingReferralsSetupRoute
  '/$orgId/marketing/reviews/replies': typeof AuthOrgIdMarketingReviewsRepliesRoute
  '/$orgId/marketing/text-keywords/$keywordId': typeof AuthOrgIdMarketingTextKeywordsKeywordIdRoute
  '/$orgId/settings/automated-messages/appointment-booked': typeof AuthOrgIdSettingsAutomatedMessagesAppointmentBookedRoute
  '/$orgId/settings/automated-messages/appointment-cancelled': typeof AuthOrgIdSettingsAutomatedMessagesAppointmentCancelledRoute
  '/$orgId/settings/automated-messages/appointment-completed': typeof AuthOrgIdSettingsAutomatedMessagesAppointmentCompletedRoute
  '/$orgId/settings/automated-messages/appointment-rescheduled': typeof AuthOrgIdSettingsAutomatedMessagesAppointmentRescheduledRoute
  '/$orgId/settings/automated-messages/check-in-process': typeof AuthOrgIdSettingsAutomatedMessagesCheckInProcessRoute
  '/$orgId/settings/automated-messages/gift-cards': typeof AuthOrgIdSettingsAutomatedMessagesGiftCardsRoute
  '/$orgId/settings/business-setup/advanced-settings': typeof AuthOrgIdSettingsBusinessSetupAdvancedSettingsRoute
  '/$orgId/settings/business-setup/business-details': typeof AuthOrgIdSettingsBusinessSetupBusinessDetailsRoute
  '/$orgId/settings/business-setup/business-hours': typeof AuthOrgIdSettingsBusinessSetupBusinessHoursRoute
  '/$orgId/settings/business-setup/how-you-use-hayven': typeof AuthOrgIdSettingsBusinessSetupHowYouUseHayvenRoute
  '/$orgId/settings/business-setup/locations': typeof AuthOrgIdSettingsBusinessSetupLocationsRoute
  '/$orgId/settings/business-setup/logo-branding': typeof AuthOrgIdSettingsBusinessSetupLogoBrandingRoute
  '/$orgId/settings/business-setup/payroll': typeof AuthOrgIdSettingsBusinessSetupPayrollRoute
  '/$orgId/settings/business-setup/phone-numbers': typeof AuthOrgIdSettingsBusinessSetupPhoneNumbersRoute
  '/$orgId/settings/calendar-appointments/cancel-reschedule': typeof AuthOrgIdSettingsCalendarAppointmentsCancelRescheduleRoute
  '/$orgId/settings/calendar-appointments/display-preferences': typeof AuthOrgIdSettingsCalendarAppointmentsDisplayPreferencesRoute
  '/$orgId/settings/calendar-appointments/no-show-protection': typeof AuthOrgIdSettingsCalendarAppointmentsNoShowProtectionRoute
  '/$orgId/settings/calendar-appointments/scheduling-options': typeof AuthOrgIdSettingsCalendarAppointmentsSchedulingOptionsRoute
  '/$orgId/settings/online-booking/preferences': typeof AuthOrgIdSettingsOnlineBookingPreferencesRoute
  '/$orgId/settings/online-booking/setup-integration': typeof AuthOrgIdSettingsOnlineBookingSetupIntegrationRoute
  '/$orgId/settings/online-booking/staff-selection': typeof AuthOrgIdSettingsOnlineBookingStaffSelectionRoute
  '/$orgId/settings/services/import': typeof AuthOrgIdSettingsServicesImportRoute
  '/$orgId/settings/services/same-time': typeof AuthOrgIdSettingsServicesSameTimeRoute
  '/$orgId/marketing/google-ranking': typeof AuthOrgIdMarketingGoogleRankingIndexRoute
  '/$orgId/marketing/new-client-offer': typeof AuthOrgIdMarketingNewClientOfferIndexRoute
  '/$orgId/marketing/referrals': typeof AuthOrgIdMarketingReferralsIndexRoute
  '/$orgId/marketing/campaigns/$campaignId/automations': typeof AuthOrgIdMarketingCampaignsCampaignIdAutomationsRoute
  '/$orgId/marketing/campaigns/$campaignId/giveaway': typeof AuthOrgIdMarketingCampaignsCampaignIdGiveawayRoute
  '/$orgId/marketing/campaigns/$campaignId/landing': typeof AuthOrgIdMarketingCampaignsCampaignIdLandingRoute
  '/$orgId/marketing/campaigns/$campaignId/published': typeof AuthOrgIdMarketingCampaignsCampaignIdPublishedRoute
  '/$orgId/marketing/campaigns/$campaignId/review': typeof AuthOrgIdMarketingCampaignsCampaignIdReviewRoute
  '/$orgId/marketing/campaigns/$campaignId/voucher': typeof AuthOrgIdMarketingCampaignsCampaignIdVoucherRoute
  '/$orgId/marketing/campaigns/new/event': typeof AuthOrgIdMarketingCampaignsNewEventRoute
  '/$orgId/marketing/campaigns/new/flyer-page': typeof AuthOrgIdMarketingCampaignsNewFlyerPageRoute
  '/$orgId/marketing/campaigns/new/giveaway': typeof AuthOrgIdMarketingCampaignsNewGiveawayRoute
  '/$orgId/marketing/campaigns/new/voucher': typeof AuthOrgIdMarketingCampaignsNewVoucherRoute
  '/$orgId/marketing/campaigns/$campaignId/giveaway/live': typeof AuthOrgIdMarketingCampaignsCampaignIdGiveawayLiveRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_dev': typeof DevRouteWithChildren
  '/login': typeof LoginRoute
  '/sign-in': typeof SignInRoute
  '/sign-up': typeof SignUpRoute
  '/_auth/$orgId': typeof AuthOrgIdRouteWithChildren
  '/_auth/agency': typeof AuthAgencyRouteWithChildren
  '/_auth/choose-salon': typeof AuthChooseSalonRoute
  '/_auth/guidance': typeof AuthGuidanceRoute
  '/_auth/$orgId/bio-page': typeof AuthOrgIdBioPageRoute
  '/_auth/$orgId/calendar': typeof AuthOrgIdCalendarRoute
  '/_auth/$orgId/clients': typeof AuthOrgIdClientsRoute
  '/_auth/$orgId/get-started': typeof AuthOrgIdGetStartedRoute
  '/_auth/$orgId/gift-cards': typeof AuthOrgIdGiftCardsRoute
  '/_auth/$orgId/inbox': typeof AuthOrgIdInboxRoute
  '/_auth/$orgId/marketing': typeof AuthOrgIdMarketingRouteWithChildren
  '/_auth/$orgId/products': typeof AuthOrgIdProductsRoute
  '/_auth/$orgId/reports': typeof AuthOrgIdReportsRouteWithChildren
  '/_auth/$orgId/sales': typeof AuthOrgIdSalesRoute
  '/_auth/$orgId/turn-tracker': typeof AuthOrgIdTurnTrackerRoute
  '/_auth/$orgId/user-settings': typeof AuthOrgIdUserSettingsRoute
  '/_auth/agency/demo-requests': typeof AuthAgencyDemoRequestsRoute
  '/_auth/agency/ein': typeof AuthAgencyEinRoute
  '/_auth/agency/google-ads': typeof AuthAgencyGoogleAdsRoute
  '/_auth/agency/google-ranking': typeof AuthAgencyGoogleRankingRoute
  '/_auth/agency/members': typeof AuthAgencyMembersRouteWithChildren
  '/_auth/agency/meta-ads': typeof AuthAgencyMetaAdsRoute
  '/_auth/agency/profile': typeof AuthAgencyProfileRoute
  '/_auth/agency/revenue-costs': typeof AuthAgencyRevenueCostsRoute
  '/_auth/agency/salon-results': typeof AuthAgencySalonResultsRoute
  '/_auth/agency/social-results': typeof AuthAgencySocialResultsRoute
  '/_auth/agency/website': typeof AuthAgencyWebsiteRoute
  '/_auth/google-business/callback': typeof AuthGoogleBusinessCallbackRoute
  '/_dev/ui-preview/inputs': typeof DevUiPreviewInputsRoute
  '/_auth/$orgId/': typeof AuthOrgIdIndexRoute
  '/_auth/agency/': typeof AuthAgencyIndexRoute
  '/_dev/ui-preview/': typeof DevUiPreviewIndexRoute
  '/_auth/$orgId/gift-cards_/settings': typeof AuthOrgIdGiftCardsSettingsRoute
  '/_auth/$orgId/marketing/analytics': typeof AuthOrgIdMarketingAnalyticsRoute
  '/_auth/$orgId/marketing/bio-page': typeof AuthOrgIdMarketingBioPageRoute
  '/_auth/$orgId/marketing/bulk-sms': typeof AuthOrgIdMarketingBulkSmsRoute
  '/_auth/$orgId/marketing/campaigns': typeof AuthOrgIdMarketingCampaignsRoute
  '/_auth/$orgId/marketing/comment-dm': typeof AuthOrgIdMarketingCommentDmRoute
  '/_auth/$orgId/marketing/creators': typeof AuthOrgIdMarketingCreatorsRoute
  '/_auth/$orgId/marketing/google-ranking': typeof AuthOrgIdMarketingGoogleRankingRouteWithChildren
  '/_auth/$orgId/marketing/hayven-tap': typeof AuthOrgIdMarketingHayvenTapRoute
  '/_auth/$orgId/marketing/leads': typeof AuthOrgIdMarketingLeadsRoute
  '/_auth/$orgId/marketing/listings': typeof AuthOrgIdMarketingListingsRoute
  '/_auth/$orgId/marketing/new-client-offer': typeof AuthOrgIdMarketingNewClientOfferRouteWithChildren
  '/_auth/$orgId/marketing/owner-report': typeof AuthOrgIdMarketingOwnerReportRoute
  '/_auth/$orgId/marketing/prizes': typeof AuthOrgIdMarketingPrizesRoute
  '/_auth/$orgId/marketing/qr-codes': typeof AuthOrgIdMarketingQrCodesRoute
  '/_auth/$orgId/marketing/referrals': typeof AuthOrgIdMarketingReferralsRouteWithChildren
  '/_auth/$orgId/marketing/reviews': typeof AuthOrgIdMarketingReviewsRoute
  '/_auth/$orgId/marketing/rewards-card': typeof AuthOrgIdMarketingRewardsCardRoute
  '/_auth/$orgId/marketing/settings': typeof AuthOrgIdMarketingSettingsRoute
  '/_auth/$orgId/marketing/text-keywords': typeof AuthOrgIdMarketingTextKeywordsRoute
  '/_auth/$orgId/reports/appointments': typeof AuthOrgIdReportsAppointmentsRoute
  '/_auth/$orgId/reports/clients': typeof AuthOrgIdReportsClientsRoute
  '/_auth/$orgId/reports/impact': typeof AuthOrgIdReportsImpactRoute
  '/_auth/$orgId/reports/marketing': typeof AuthOrgIdReportsMarketingRoute
  '/_auth/$orgId/reports/reviews': typeof AuthOrgIdReportsReviewsRoute
  '/_auth/$orgId/reports/sales': typeof AuthOrgIdReportsSalesRoute
  '/_auth/$orgId/reports/team': typeof AuthOrgIdReportsTeamRoute
  '/_auth/$orgId/reports/today': typeof AuthOrgIdReportsTodayRoute
  '/_auth/$orgId/settings/appearance': typeof AuthOrgIdSettingsAppearanceRoute
  '/_auth/$orgId/settings/calls': typeof AuthOrgIdSettingsCallsRoute
  '/_auth/$orgId/settings/check-in': typeof AuthOrgIdSettingsCheckInRoute
  '/_auth/$orgId/settings/integrations': typeof AuthOrgIdSettingsIntegrationsRoute
  '/_auth/$orgId/settings/link-in-bio': typeof AuthOrgIdSettingsLinkInBioRoute
  '/_auth/$orgId/settings/marketing-access': typeof AuthOrgIdSettingsMarketingAccessRoute
  '/_auth/$orgId/settings/plan-and-usage': typeof AuthOrgIdSettingsPlanAndUsageRoute
  '/_auth/$orgId/settings/services': typeof AuthOrgIdSettingsServicesRoute
  '/_auth/$orgId/settings/staff': typeof AuthOrgIdSettingsStaffRoute
  '/_auth/$orgId/settings/turn-tracker': typeof AuthOrgIdSettingsTurnTrackerRoute
  '/_auth/agency/ads-doctor/$shortCode': typeof AuthAgencyAdsDoctorShortCodeRoute
  '/_auth/agency/ads-doctor/ask': typeof AuthAgencyAdsDoctorAskRoute
  '/_auth/agency/counter-stands/program': typeof AuthAgencyCounterStandsProgramRoute
  '/_auth/agency/guidance/$slug': typeof AuthAgencyGuidanceSlugRoute
  '/_auth/agency/members/$memberId': typeof AuthAgencyMembersMemberIdRoute
  '/_auth/agency/members/new': typeof AuthAgencyMembersNewRoute
  '/_auth/agency/salons/$shortCode': typeof AuthAgencySalonsShortCodeRoute
  '/_auth/agency/salons/new': typeof AuthAgencySalonsNewRoute
  '/_auth/meta/comment-to-dm/callback': typeof AuthMetaCommentToDmCallbackRoute
  '/_auth/$orgId/marketing/': typeof AuthOrgIdMarketingIndexRoute
  '/_auth/$orgId/reports/': typeof AuthOrgIdReportsIndexRoute
  '/_auth/$orgId/settings/': typeof AuthOrgIdSettingsIndexRoute
  '/_auth/agency/ads-doctor/': typeof AuthAgencyAdsDoctorIndexRoute
  '/_auth/agency/google-business/': typeof AuthAgencyGoogleBusinessIndexRoute
  '/_auth/agency/guidance/': typeof AuthAgencyGuidanceIndexRoute
  '/_auth/agency/members/': typeof AuthAgencyMembersIndexRoute
  '/_auth/agency/salons/': typeof AuthAgencySalonsIndexRoute
  '/_auth/$orgId/marketing/bulk-sms_/$bulkSendId': typeof AuthOrgIdMarketingBulkSmsBulkSendIdRoute
  '/_auth/$orgId/marketing/campaigns_/$campaignId': typeof AuthOrgIdMarketingCampaignsCampaignIdRoute
  '/_auth/$orgId/marketing/campaigns_/new': typeof AuthOrgIdMarketingCampaignsNewRoute
  '/_auth/$orgId/marketing/comment-dm_/$automationId': typeof AuthOrgIdMarketingCommentDmAutomationIdRoute
  '/_auth/$orgId/marketing/comment-dm_/auto-reply': typeof AuthOrgIdMarketingCommentDmAutoReplyRoute
  '/_auth/$orgId/marketing/comment-dm_/new': typeof AuthOrgIdMarketingCommentDmNewRoute
  '/_auth/$orgId/marketing/creators_/$creatorId': typeof AuthOrgIdMarketingCreatorsCreatorIdRoute
  '/_auth/$orgId/marketing/google-ranking/posts': typeof AuthOrgIdMarketingGoogleRankingPostsRoute
  '/_auth/$orgId/marketing/google-ranking/profile': typeof AuthOrgIdMarketingGoogleRankingProfileRoute
  '/_auth/$orgId/marketing/google-ranking_/photos': typeof AuthOrgIdMarketingGoogleRankingPhotosRoute
  '/_auth/$orgId/marketing/new-client-offer/guests': typeof AuthOrgIdMarketingNewClientOfferGuestsRoute
  '/_auth/$orgId/marketing/new-client-offer/setup': typeof AuthOrgIdMarketingNewClientOfferSetupRoute
  '/_auth/$orgId/marketing/referrals/setup': typeof AuthOrgIdMarketingReferralsSetupRoute
  '/_auth/$orgId/marketing/reviews_/replies': typeof AuthOrgIdMarketingReviewsRepliesRoute
  '/_auth/$orgId/marketing/text-keywords_/$keywordId': typeof AuthOrgIdMarketingTextKeywordsKeywordIdRoute
  '/_auth/$orgId/settings/automated-messages/appointment-booked': typeof AuthOrgIdSettingsAutomatedMessagesAppointmentBookedRoute
  '/_auth/$orgId/settings/automated-messages/appointment-cancelled': typeof AuthOrgIdSettingsAutomatedMessagesAppointmentCancelledRoute
  '/_auth/$orgId/settings/automated-messages/appointment-completed': typeof AuthOrgIdSettingsAutomatedMessagesAppointmentCompletedRoute
  '/_auth/$orgId/settings/automated-messages/appointment-rescheduled': typeof AuthOrgIdSettingsAutomatedMessagesAppointmentRescheduledRoute
  '/_auth/$orgId/settings/automated-messages/check-in-process': typeof AuthOrgIdSettingsAutomatedMessagesCheckInProcessRoute
  '/_auth/$orgId/settings/automated-messages/gift-cards': typeof AuthOrgIdSettingsAutomatedMessagesGiftCardsRoute
  '/_auth/$orgId/settings/business-setup/advanced-settings': typeof AuthOrgIdSettingsBusinessSetupAdvancedSettingsRoute
  '/_auth/$orgId/settings/business-setup/business-details': typeof AuthOrgIdSettingsBusinessSetupBusinessDetailsRoute
  '/_auth/$orgId/settings/business-setup/business-hours': typeof AuthOrgIdSettingsBusinessSetupBusinessHoursRoute
  '/_auth/$orgId/settings/business-setup/how-you-use-hayven': typeof AuthOrgIdSettingsBusinessSetupHowYouUseHayvenRoute
  '/_auth/$orgId/settings/business-setup/locations': typeof AuthOrgIdSettingsBusinessSetupLocationsRoute
  '/_auth/$orgId/settings/business-setup/logo-branding': typeof AuthOrgIdSettingsBusinessSetupLogoBrandingRoute
  '/_auth/$orgId/settings/business-setup/payroll': typeof AuthOrgIdSettingsBusinessSetupPayrollRoute
  '/_auth/$orgId/settings/business-setup/phone-numbers': typeof AuthOrgIdSettingsBusinessSetupPhoneNumbersRoute
  '/_auth/$orgId/settings/calendar-appointments/cancel-reschedule': typeof AuthOrgIdSettingsCalendarAppointmentsCancelRescheduleRoute
  '/_auth/$orgId/settings/calendar-appointments/display-preferences': typeof AuthOrgIdSettingsCalendarAppointmentsDisplayPreferencesRoute
  '/_auth/$orgId/settings/calendar-appointments/no-show-protection': typeof AuthOrgIdSettingsCalendarAppointmentsNoShowProtectionRoute
  '/_auth/$orgId/settings/calendar-appointments/scheduling-options': typeof AuthOrgIdSettingsCalendarAppointmentsSchedulingOptionsRoute
  '/_auth/$orgId/settings/online-booking/preferences': typeof AuthOrgIdSettingsOnlineBookingPreferencesRoute
  '/_auth/$orgId/settings/online-booking/setup-integration': typeof AuthOrgIdSettingsOnlineBookingSetupIntegrationRoute
  '/_auth/$orgId/settings/online-booking/staff-selection': typeof AuthOrgIdSettingsOnlineBookingStaffSelectionRoute
  '/_auth/$orgId/settings/services_/import': typeof AuthOrgIdSettingsServicesImportRoute
  '/_auth/$orgId/settings/services_/same-time': typeof AuthOrgIdSettingsServicesSameTimeRoute
  '/_auth/$orgId/marketing/google-ranking/': typeof AuthOrgIdMarketingGoogleRankingIndexRoute
  '/_auth/$orgId/marketing/new-client-offer/': typeof AuthOrgIdMarketingNewClientOfferIndexRoute
  '/_auth/$orgId/marketing/referrals/': typeof AuthOrgIdMarketingReferralsIndexRoute
  '/_auth/$orgId/marketing/campaigns_/$campaignId_/automations': typeof AuthOrgIdMarketingCampaignsCampaignIdAutomationsRoute
  '/_auth/$orgId/marketing/campaigns_/$campaignId_/giveaway': typeof AuthOrgIdMarketingCampaignsCampaignIdGiveawayRoute
  '/_auth/$orgId/marketing/campaigns_/$campaignId_/landing': typeof AuthOrgIdMarketingCampaignsCampaignIdLandingRoute
  '/_auth/$orgId/marketing/campaigns_/$campaignId_/published': typeof AuthOrgIdMarketingCampaignsCampaignIdPublishedRoute
  '/_auth/$orgId/marketing/campaigns_/$campaignId_/review': typeof AuthOrgIdMarketingCampaignsCampaignIdReviewRoute
  '/_auth/$orgId/marketing/campaigns_/$campaignId_/voucher': typeof AuthOrgIdMarketingCampaignsCampaignIdVoucherRoute
  '/_auth/$orgId/marketing/campaigns_/new_/event': typeof AuthOrgIdMarketingCampaignsNewEventRoute
  '/_auth/$orgId/marketing/campaigns_/new_/flyer-page': typeof AuthOrgIdMarketingCampaignsNewFlyerPageRoute
  '/_auth/$orgId/marketing/campaigns_/new_/giveaway': typeof AuthOrgIdMarketingCampaignsNewGiveawayRoute
  '/_auth/$orgId/marketing/campaigns_/new_/voucher': typeof AuthOrgIdMarketingCampaignsNewVoucherRoute
  '/_auth/$orgId/marketing/campaigns_/$campaignId_/giveaway_/live': typeof AuthOrgIdMarketingCampaignsCampaignIdGiveawayLiveRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/sign-in'
    | '/sign-up'
    | '/$orgId'
    | '/agency'
    | '/choose-salon'
    | '/guidance'
    | '/$orgId/bio-page'
    | '/$orgId/calendar'
    | '/$orgId/clients'
    | '/$orgId/get-started'
    | '/$orgId/gift-cards'
    | '/$orgId/inbox'
    | '/$orgId/marketing'
    | '/$orgId/products'
    | '/$orgId/reports'
    | '/$orgId/sales'
    | '/$orgId/turn-tracker'
    | '/$orgId/user-settings'
    | '/agency/demo-requests'
    | '/agency/ein'
    | '/agency/google-ads'
    | '/agency/google-ranking'
    | '/agency/members'
    | '/agency/meta-ads'
    | '/agency/profile'
    | '/agency/revenue-costs'
    | '/agency/salon-results'
    | '/agency/social-results'
    | '/agency/website'
    | '/google-business/callback'
    | '/ui-preview/inputs'
    | '/$orgId/'
    | '/agency/'
    | '/ui-preview'
    | '/$orgId/gift-cards/settings'
    | '/$orgId/marketing/analytics'
    | '/$orgId/marketing/bio-page'
    | '/$orgId/marketing/bulk-sms'
    | '/$orgId/marketing/campaigns'
    | '/$orgId/marketing/comment-dm'
    | '/$orgId/marketing/creators'
    | '/$orgId/marketing/google-ranking'
    | '/$orgId/marketing/hayven-tap'
    | '/$orgId/marketing/leads'
    | '/$orgId/marketing/listings'
    | '/$orgId/marketing/new-client-offer'
    | '/$orgId/marketing/owner-report'
    | '/$orgId/marketing/prizes'
    | '/$orgId/marketing/qr-codes'
    | '/$orgId/marketing/referrals'
    | '/$orgId/marketing/reviews'
    | '/$orgId/marketing/rewards-card'
    | '/$orgId/marketing/settings'
    | '/$orgId/marketing/text-keywords'
    | '/$orgId/reports/appointments'
    | '/$orgId/reports/clients'
    | '/$orgId/reports/impact'
    | '/$orgId/reports/marketing'
    | '/$orgId/reports/reviews'
    | '/$orgId/reports/sales'
    | '/$orgId/reports/team'
    | '/$orgId/reports/today'
    | '/$orgId/settings/appearance'
    | '/$orgId/settings/calls'
    | '/$orgId/settings/check-in'
    | '/$orgId/settings/integrations'
    | '/$orgId/settings/link-in-bio'
    | '/$orgId/settings/marketing-access'
    | '/$orgId/settings/plan-and-usage'
    | '/$orgId/settings/services'
    | '/$orgId/settings/staff'
    | '/$orgId/settings/turn-tracker'
    | '/agency/ads-doctor/$shortCode'
    | '/agency/ads-doctor/ask'
    | '/agency/counter-stands/program'
    | '/agency/guidance/$slug'
    | '/agency/members/$memberId'
    | '/agency/members/new'
    | '/agency/salons/$shortCode'
    | '/agency/salons/new'
    | '/meta/comment-to-dm/callback'
    | '/$orgId/marketing/'
    | '/$orgId/reports/'
    | '/$orgId/settings'
    | '/agency/ads-doctor'
    | '/agency/google-business'
    | '/agency/guidance'
    | '/agency/members/'
    | '/agency/salons'
    | '/$orgId/marketing/bulk-sms/$bulkSendId'
    | '/$orgId/marketing/campaigns/$campaignId'
    | '/$orgId/marketing/campaigns/new'
    | '/$orgId/marketing/comment-dm/$automationId'
    | '/$orgId/marketing/comment-dm/auto-reply'
    | '/$orgId/marketing/comment-dm/new'
    | '/$orgId/marketing/creators/$creatorId'
    | '/$orgId/marketing/google-ranking/posts'
    | '/$orgId/marketing/google-ranking/profile'
    | '/$orgId/marketing/google-ranking/photos'
    | '/$orgId/marketing/new-client-offer/guests'
    | '/$orgId/marketing/new-client-offer/setup'
    | '/$orgId/marketing/referrals/setup'
    | '/$orgId/marketing/reviews/replies'
    | '/$orgId/marketing/text-keywords/$keywordId'
    | '/$orgId/settings/automated-messages/appointment-booked'
    | '/$orgId/settings/automated-messages/appointment-cancelled'
    | '/$orgId/settings/automated-messages/appointment-completed'
    | '/$orgId/settings/automated-messages/appointment-rescheduled'
    | '/$orgId/settings/automated-messages/check-in-process'
    | '/$orgId/settings/automated-messages/gift-cards'
    | '/$orgId/settings/business-setup/advanced-settings'
    | '/$orgId/settings/business-setup/business-details'
    | '/$orgId/settings/business-setup/business-hours'
    | '/$orgId/settings/business-setup/how-you-use-hayven'
    | '/$orgId/settings/business-setup/locations'
    | '/$orgId/settings/business-setup/logo-branding'
    | '/$orgId/settings/business-setup/payroll'
    | '/$orgId/settings/business-setup/phone-numbers'
    | '/$orgId/settings/calendar-appointments/cancel-reschedule'
    | '/$orgId/settings/calendar-appointments/display-preferences'
    | '/$orgId/settings/calendar-appointments/no-show-protection'
    | '/$orgId/settings/calendar-appointments/scheduling-options'
    | '/$orgId/settings/online-booking/preferences'
    | '/$orgId/settings/online-booking/setup-integration'
    | '/$orgId/settings/online-booking/staff-selection'
    | '/$orgId/settings/services/import'
    | '/$orgId/settings/services/same-time'
    | '/$orgId/marketing/google-ranking/'
    | '/$orgId/marketing/new-client-offer/'
    | '/$orgId/marketing/referrals/'
    | '/$orgId/marketing/campaigns/$campaignId/automations'
    | '/$orgId/marketing/campaigns/$campaignId/giveaway'
    | '/$orgId/marketing/campaigns/$campaignId/landing'
    | '/$orgId/marketing/campaigns/$campaignId/published'
    | '/$orgId/marketing/campaigns/$campaignId/review'
    | '/$orgId/marketing/campaigns/$campaignId/voucher'
    | '/$orgId/marketing/campaigns/new/event'
    | '/$orgId/marketing/campaigns/new/flyer-page'
    | '/$orgId/marketing/campaigns/new/giveaway'
    | '/$orgId/marketing/campaigns/new/voucher'
    | '/$orgId/marketing/campaigns/$campaignId/giveaway/live'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/sign-in'
    | '/sign-up'
    | '/choose-salon'
    | '/guidance'
    | '/$orgId/bio-page'
    | '/$orgId/calendar'
    | '/$orgId/clients'
    | '/$orgId/get-started'
    | '/$orgId/gift-cards'
    | '/$orgId/inbox'
    | '/$orgId/products'
    | '/$orgId/sales'
    | '/$orgId/turn-tracker'
    | '/$orgId/user-settings'
    | '/agency/demo-requests'
    | '/agency/ein'
    | '/agency/google-ads'
    | '/agency/google-ranking'
    | '/agency/meta-ads'
    | '/agency/profile'
    | '/agency/revenue-costs'
    | '/agency/salon-results'
    | '/agency/social-results'
    | '/agency/website'
    | '/google-business/callback'
    | '/ui-preview/inputs'
    | '/$orgId'
    | '/agency'
    | '/ui-preview'
    | '/$orgId/gift-cards/settings'
    | '/$orgId/marketing/analytics'
    | '/$orgId/marketing/bio-page'
    | '/$orgId/marketing/bulk-sms'
    | '/$orgId/marketing/campaigns'
    | '/$orgId/marketing/comment-dm'
    | '/$orgId/marketing/creators'
    | '/$orgId/marketing/hayven-tap'
    | '/$orgId/marketing/leads'
    | '/$orgId/marketing/listings'
    | '/$orgId/marketing/owner-report'
    | '/$orgId/marketing/prizes'
    | '/$orgId/marketing/qr-codes'
    | '/$orgId/marketing/reviews'
    | '/$orgId/marketing/rewards-card'
    | '/$orgId/marketing/settings'
    | '/$orgId/marketing/text-keywords'
    | '/$orgId/reports/appointments'
    | '/$orgId/reports/clients'
    | '/$orgId/reports/impact'
    | '/$orgId/reports/marketing'
    | '/$orgId/reports/reviews'
    | '/$orgId/reports/sales'
    | '/$orgId/reports/team'
    | '/$orgId/reports/today'
    | '/$orgId/settings/appearance'
    | '/$orgId/settings/calls'
    | '/$orgId/settings/check-in'
    | '/$orgId/settings/integrations'
    | '/$orgId/settings/link-in-bio'
    | '/$orgId/settings/marketing-access'
    | '/$orgId/settings/plan-and-usage'
    | '/$orgId/settings/services'
    | '/$orgId/settings/staff'
    | '/$orgId/settings/turn-tracker'
    | '/agency/ads-doctor/$shortCode'
    | '/agency/ads-doctor/ask'
    | '/agency/counter-stands/program'
    | '/agency/guidance/$slug'
    | '/agency/members/$memberId'
    | '/agency/members/new'
    | '/agency/salons/$shortCode'
    | '/agency/salons/new'
    | '/meta/comment-to-dm/callback'
    | '/$orgId/marketing'
    | '/$orgId/reports'
    | '/$orgId/settings'
    | '/agency/ads-doctor'
    | '/agency/google-business'
    | '/agency/guidance'
    | '/agency/members'
    | '/agency/salons'
    | '/$orgId/marketing/bulk-sms/$bulkSendId'
    | '/$orgId/marketing/campaigns/$campaignId'
    | '/$orgId/marketing/campaigns/new'
    | '/$orgId/marketing/comment-dm/$automationId'
    | '/$orgId/marketing/comment-dm/auto-reply'
    | '/$orgId/marketing/comment-dm/new'
    | '/$orgId/marketing/creators/$creatorId'
    | '/$orgId/marketing/google-ranking/posts'
    | '/$orgId/marketing/google-ranking/profile'
    | '/$orgId/marketing/google-ranking/photos'
    | '/$orgId/marketing/new-client-offer/guests'
    | '/$orgId/marketing/new-client-offer/setup'
    | '/$orgId/marketing/referrals/setup'
    | '/$orgId/marketing/reviews/replies'
    | '/$orgId/marketing/text-keywords/$keywordId'
    | '/$orgId/settings/automated-messages/appointment-booked'
    | '/$orgId/settings/automated-messages/appointment-cancelled'
    | '/$orgId/settings/automated-messages/appointment-completed'
    | '/$orgId/settings/automated-messages/appointment-rescheduled'
    | '/$orgId/settings/automated-messages/check-in-process'
    | '/$orgId/settings/automated-messages/gift-cards'
    | '/$orgId/settings/business-setup/advanced-settings'
    | '/$orgId/settings/business-setup/business-details'
    | '/$orgId/settings/business-setup/business-hours'
    | '/$orgId/settings/business-setup/how-you-use-hayven'
    | '/$orgId/settings/business-setup/locations'
    | '/$orgId/settings/business-setup/logo-branding'
    | '/$orgId/settings/business-setup/payroll'
    | '/$orgId/settings/business-setup/phone-numbers'
    | '/$orgId/settings/calendar-appointments/cancel-reschedule'
    | '/$orgId/settings/calendar-appointments/display-preferences'
    | '/$orgId/settings/calendar-appointments/no-show-protection'
    | '/$orgId/settings/calendar-appointments/scheduling-options'
    | '/$orgId/settings/online-booking/preferences'
    | '/$orgId/settings/online-booking/setup-integration'
    | '/$orgId/settings/online-booking/staff-selection'
    | '/$orgId/settings/services/import'
    | '/$orgId/settings/services/same-time'
    | '/$orgId/marketing/google-ranking'
    | '/$orgId/marketing/new-client-offer'
    | '/$orgId/marketing/referrals'
    | '/$orgId/marketing/campaigns/$campaignId/automations'
    | '/$orgId/marketing/campaigns/$campaignId/giveaway'
    | '/$orgId/marketing/campaigns/$campaignId/landing'
    | '/$orgId/marketing/campaigns/$campaignId/published'
    | '/$orgId/marketing/campaigns/$campaignId/review'
    | '/$orgId/marketing/campaigns/$campaignId/voucher'
    | '/$orgId/marketing/campaigns/new/event'
    | '/$orgId/marketing/campaigns/new/flyer-page'
    | '/$orgId/marketing/campaigns/new/giveaway'
    | '/$orgId/marketing/campaigns/new/voucher'
    | '/$orgId/marketing/campaigns/$campaignId/giveaway/live'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_dev'
    | '/login'
    | '/sign-in'
    | '/sign-up'
    | '/_auth/$orgId'
    | '/_auth/agency'
    | '/_auth/choose-salon'
    | '/_auth/guidance'
    | '/_auth/$orgId/bio-page'
    | '/_auth/$orgId/calendar'
    | '/_auth/$orgId/clients'
    | '/_auth/$orgId/get-started'
    | '/_auth/$orgId/gift-cards'
    | '/_auth/$orgId/inbox'
    | '/_auth/$orgId/marketing'
    | '/_auth/$orgId/products'
    | '/_auth/$orgId/reports'
    | '/_auth/$orgId/sales'
    | '/_auth/$orgId/turn-tracker'
    | '/_auth/$orgId/user-settings'
    | '/_auth/agency/demo-requests'
    | '/_auth/agency/ein'
    | '/_auth/agency/google-ads'
    | '/_auth/agency/google-ranking'
    | '/_auth/agency/members'
    | '/_auth/agency/meta-ads'
    | '/_auth/agency/profile'
    | '/_auth/agency/revenue-costs'
    | '/_auth/agency/salon-results'
    | '/_auth/agency/social-results'
    | '/_auth/agency/website'
    | '/_auth/google-business/callback'
    | '/_dev/ui-preview/inputs'
    | '/_auth/$orgId/'
    | '/_auth/agency/'
    | '/_dev/ui-preview/'
    | '/_auth/$orgId/gift-cards_/settings'
    | '/_auth/$orgId/marketing/analytics'
    | '/_auth/$orgId/marketing/bio-page'
    | '/_auth/$orgId/marketing/bulk-sms'
    | '/_auth/$orgId/marketing/campaigns'
    | '/_auth/$orgId/marketing/comment-dm'
    | '/_auth/$orgId/marketing/creators'
    | '/_auth/$orgId/marketing/google-ranking'
    | '/_auth/$orgId/marketing/hayven-tap'
    | '/_auth/$orgId/marketing/leads'
    | '/_auth/$orgId/marketing/listings'
    | '/_auth/$orgId/marketing/new-client-offer'
    | '/_auth/$orgId/marketing/owner-report'
    | '/_auth/$orgId/marketing/prizes'
    | '/_auth/$orgId/marketing/qr-codes'
    | '/_auth/$orgId/marketing/referrals'
    | '/_auth/$orgId/marketing/reviews'
    | '/_auth/$orgId/marketing/rewards-card'
    | '/_auth/$orgId/marketing/settings'
    | '/_auth/$orgId/marketing/text-keywords'
    | '/_auth/$orgId/reports/appointments'
    | '/_auth/$orgId/reports/clients'
    | '/_auth/$orgId/reports/impact'
    | '/_auth/$orgId/reports/marketing'
    | '/_auth/$orgId/reports/reviews'
    | '/_auth/$orgId/reports/sales'
    | '/_auth/$orgId/reports/team'
    | '/_auth/$orgId/reports/today'
    | '/_auth/$orgId/settings/appearance'
    | '/_auth/$orgId/settings/calls'
    | '/_auth/$orgId/settings/check-in'
    | '/_auth/$orgId/settings/integrations'
    | '/_auth/$orgId/settings/link-in-bio'
    | '/_auth/$orgId/settings/marketing-access'
    | '/_auth/$orgId/settings/plan-and-usage'
    | '/_auth/$orgId/settings/services'
    | '/_auth/$orgId/settings/staff'
    | '/_auth/$orgId/settings/turn-tracker'
    | '/_auth/agency/ads-doctor/$shortCode'
    | '/_auth/agency/ads-doctor/ask'
    | '/_auth/agency/counter-stands/program'
    | '/_auth/agency/guidance/$slug'
    | '/_auth/agency/members/$memberId'
    | '/_auth/agency/members/new'
    | '/_auth/agency/salons/$shortCode'
    | '/_auth/agency/salons/new'
    | '/_auth/meta/comment-to-dm/callback'
    | '/_auth/$orgId/marketing/'
    | '/_auth/$orgId/reports/'
    | '/_auth/$orgId/settings/'
    | '/_auth/agency/ads-doctor/'
    | '/_auth/agency/google-business/'
    | '/_auth/agency/guidance/'
    | '/_auth/agency/members/'
    | '/_auth/agency/salons/'
    | '/_auth/$orgId/marketing/bulk-sms_/$bulkSendId'
    | '/_auth/$orgId/marketing/campaigns_/$campaignId'
    | '/_auth/$orgId/marketing/campaigns_/new'
    | '/_auth/$orgId/marketing/comment-dm_/$automationId'
    | '/_auth/$orgId/marketing/comment-dm_/auto-reply'
    | '/_auth/$orgId/marketing/comment-dm_/new'
    | '/_auth/$orgId/marketing/creators_/$creatorId'
    | '/_auth/$orgId/marketing/google-ranking/posts'
    | '/_auth/$orgId/marketing/google-ranking/profile'
    | '/_auth/$orgId/marketing/google-ranking_/photos'
    | '/_auth/$orgId/marketing/new-client-offer/guests'
    | '/_auth/$orgId/marketing/new-client-offer/setup'
    | '/_auth/$orgId/marketing/referrals/setup'
    | '/_auth/$orgId/marketing/reviews_/replies'
    | '/_auth/$orgId/marketing/text-keywords_/$keywordId'
    | '/_auth/$orgId/settings/automated-messages/appointment-booked'
    | '/_auth/$orgId/settings/automated-messages/appointment-cancelled'
    | '/_auth/$orgId/settings/automated-messages/appointment-completed'
    | '/_auth/$orgId/settings/automated-messages/appointment-rescheduled'
    | '/_auth/$orgId/settings/automated-messages/check-in-process'
    | '/_auth/$orgId/settings/automated-messages/gift-cards'
    | '/_auth/$orgId/settings/business-setup/advanced-settings'
    | '/_auth/$orgId/settings/business-setup/business-details'
    | '/_auth/$orgId/settings/business-setup/business-hours'
    | '/_auth/$orgId/settings/business-setup/how-you-use-hayven'
    | '/_auth/$orgId/settings/business-setup/locations'
    | '/_auth/$orgId/settings/business-setup/logo-branding'
    | '/_auth/$orgId/settings/business-setup/payroll'
    | '/_auth/$orgId/settings/business-setup/phone-numbers'
    | '/_auth/$orgId/settings/calendar-appointments/cancel-reschedule'
    | '/_auth/$orgId/settings/calendar-appointments/display-preferences'
    | '/_auth/$orgId/settings/calendar-appointments/no-show-protection'
    | '/_auth/$orgId/settings/calendar-appointments/scheduling-options'
    | '/_auth/$orgId/settings/online-booking/preferences'
    | '/_auth/$orgId/settings/online-booking/setup-integration'
    | '/_auth/$orgId/settings/online-booking/staff-selection'
    | '/_auth/$orgId/settings/services_/import'
    | '/_auth/$orgId/settings/services_/same-time'
    | '/_auth/$orgId/marketing/google-ranking/'
    | '/_auth/$orgId/marketing/new-client-offer/'
    | '/_auth/$orgId/marketing/referrals/'
    | '/_auth/$orgId/marketing/campaigns_/$campaignId_/automations'
    | '/_auth/$orgId/marketing/campaigns_/$campaignId_/giveaway'
    | '/_auth/$orgId/marketing/campaigns_/$campaignId_/landing'
    | '/_auth/$orgId/marketing/campaigns_/$campaignId_/published'
    | '/_auth/$orgId/marketing/campaigns_/$campaignId_/review'
    | '/_auth/$orgId/marketing/campaigns_/$campaignId_/voucher'
    | '/_auth/$orgId/marketing/campaigns_/new_/event'
    | '/_auth/$orgId/marketing/campaigns_/new_/flyer-page'
    | '/_auth/$orgId/marketing/campaigns_/new_/giveaway'
    | '/_auth/$orgId/marketing/campaigns_/new_/voucher'
    | '/_auth/$orgId/marketing/campaigns_/$campaignId_/giveaway_/live'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  DevRoute: typeof DevRouteWithChildren
  LoginRoute: typeof LoginRoute
  SignInRoute: typeof SignInRoute
  SignUpRoute: typeof SignUpRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dev': {
      id: '/_dev'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DevRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/guidance': {
      id: '/_auth/guidance'
      path: '/guidance'
      fullPath: '/guidance'
      preLoaderRoute: typeof AuthGuidanceRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/choose-salon': {
      id: '/_auth/choose-salon'
      path: '/choose-salon'
      fullPath: '/choose-salon'
      preLoaderRoute: typeof AuthChooseSalonRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/agency': {
      id: '/_auth/agency'
      path: '/agency'
      fullPath: '/agency'
      preLoaderRoute: typeof AuthAgencyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/$orgId': {
      id: '/_auth/$orgId'
      path: '/$orgId'
      fullPath: '/$orgId'
      preLoaderRoute: typeof AuthOrgIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_dev/ui-preview/': {
      id: '/_dev/ui-preview/'
      path: '/ui-preview'
      fullPath: '/ui-preview'
      preLoaderRoute: typeof DevUiPreviewIndexRouteImport
      parentRoute: typeof DevRoute
    }
    '/_auth/agency/': {
      id: '/_auth/agency/'
      path: '/'
      fullPath: '/agency/'
      preLoaderRoute: typeof AuthAgencyIndexRouteImport
      parentRoute: typeof AuthAgencyRoute
    }
    '/_auth/$orgId/': {
      id: '/_auth/$orgId/'
      path: '/'
      fullPath: '/$orgId/'
      preLoaderRoute: typeof AuthOrgIdIndexRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_dev/ui-preview/inputs': {
      id: '/_dev/ui-preview/inputs'
      path: '/ui-preview/inputs'
      fullPath: '/ui-preview/inputs'
      preLoaderRoute: typeof DevUiPreviewInputsRouteImport
      parentRoute: typeof DevRoute
    }
    '/_auth/google-business/callback': {
      id: '/_auth/google-business/callback'
      path: '/google-business/callback'
      fullPath: '/google-business/callback'
      preLoaderRoute: typeof AuthGoogleBusinessCallbackRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/agency/website': {
      id: '/_auth/agency/website'
      path: '/website'
      fullPath: '/agency/website'
      preLoaderRoute: typeof AuthAgencyWebsiteRouteImport
      parentRoute: typeof AuthAgencyRoute
    }
    '/_auth/agency/social-results': {
      id: '/_auth/agency/social-results'
      path: '/social-results'
      fullPath: '/agency/social-results'
      preLoaderRoute: typeof AuthAgencySocialResultsRouteImport
      parentRoute: typeof AuthAgencyRoute
    }
    '/_auth/agency/salon-results': {
      id: '/_auth/agency/salon-results'
      path: '/salon-results'
      fullPath: '/agency/salon-results'
      preLoaderRoute: typeof AuthAgencySalonResultsRouteImport
      parentRoute: typeof AuthAgencyRoute
    }
    '/_auth/agency/revenue-costs': {
      id: '/_auth/agency/revenue-costs'
      path: '/revenue-costs'
      fullPath: '/agency/revenue-costs'
      preLoaderRoute: typeof AuthAgencyRevenueCostsRouteImport
      parentRoute: typeof AuthAgencyRoute
    }
    '/_auth/agency/profile': {
      id: '/_auth/agency/profile'
      path: '/profile'
      fullPath: '/agency/profile'
      preLoaderRoute: typeof AuthAgencyProfileRouteImport
      parentRoute: typeof AuthAgencyRoute
    }
    '/_auth/agency/meta-ads': {
      id: '/_auth/agency/meta-ads'
      path: '/meta-ads'
      fullPath: '/agency/meta-ads'
      preLoaderRoute: typeof AuthAgencyMetaAdsRouteImport
      parentRoute: typeof AuthAgencyRoute
    }
    '/_auth/agency/members': {
      id: '/_auth/agency/members'
      path: '/members'
      fullPath: '/agency/members'
      preLoaderRoute: typeof AuthAgencyMembersRouteImport
      parentRoute: typeof AuthAgencyRoute
    }
    '/_auth/agency/google-ranking': {
      id: '/_auth/agency/google-ranking'
      path: '/google-ranking'
      fullPath: '/agency/google-ranking'
      preLoaderRoute: typeof AuthAgencyGoogleRankingRouteImport
      parentRoute: typeof AuthAgencyRoute
    }
    '/_auth/agency/google-ads': {
      id: '/_auth/agency/google-ads'
      path: '/google-ads'
      fullPath: '/agency/google-ads'
      preLoaderRoute: typeof AuthAgencyGoogleAdsRouteImport
      parentRoute: typeof AuthAgencyRoute
    }
    '/_auth/agency/ein': {
      id: '/_auth/agency/ein'
      path: '/ein'
      fullPath: '/agency/ein'
      preLoaderRoute: typeof AuthAgencyEinRouteImport
      parentRoute: typeof AuthAgencyRoute
    }
    '/_auth/agency/demo-requests': {
      id: '/_auth/agency/demo-requests'
      path: '/demo-requests'
      fullPath: '/agency/demo-requests'
      preLoaderRoute: typeof AuthAgencyDemoRequestsRouteImport
      parentRoute: typeof AuthAgencyRoute
    }
    '/_auth/$orgId/user-settings': {
      id: '/_auth/$orgId/user-settings'
      path: '/user-settings'
      fullPath: '/$orgId/user-settings'
      preLoaderRoute: typeof AuthOrgIdUserSettingsRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/turn-tracker': {
      id: '/_auth/$orgId/turn-tracker'
      path: '/turn-tracker'
      fullPath: '/$orgId/turn-tracker'
      preLoaderRoute: typeof AuthOrgIdTurnTrackerRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/sales': {
      id: '/_auth/$orgId/sales'
      path: '/sales'
      fullPath: '/$orgId/sales'
      preLoaderRoute: typeof AuthOrgIdSalesRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/reports': {
      id: '/_auth/$orgId/reports'
      path: '/reports'
      fullPath: '/$orgId/reports'
      preLoaderRoute: typeof AuthOrgIdReportsRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/products': {
      id: '/_auth/$orgId/products'
      path: '/products'
      fullPath: '/$orgId/products'
      preLoaderRoute: typeof AuthOrgIdProductsRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/marketing': {
      id: '/_auth/$orgId/marketing'
      path: '/marketing'
      fullPath: '/$orgId/marketing'
      preLoaderRoute: typeof AuthOrgIdMarketingRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/inbox': {
      id: '/_auth/$orgId/inbox'
      path: '/inbox'
      fullPath: '/$orgId/inbox'
      preLoaderRoute: typeof AuthOrgIdInboxRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/gift-cards': {
      id: '/_auth/$orgId/gift-cards'
      path: '/gift-cards'
      fullPath: '/$orgId/gift-cards'
      preLoaderRoute: typeof AuthOrgIdGiftCardsRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/get-started': {
      id: '/_auth/$orgId/get-started'
      path: '/get-started'
      fullPath: '/$orgId/get-started'
      preLoaderRoute: typeof AuthOrgIdGetStartedRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/clients': {
      id: '/_auth/$orgId/clients'
      path: '/clients'
      fullPath: '/$orgId/clients'
      preLoaderRoute: typeof AuthOrgIdClientsRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/calendar': {
      id: '/_auth/$orgId/calendar'
      path: '/calendar'
      fullPath: '/$orgId/calendar'
      preLoaderRoute: typeof AuthOrgIdCalendarRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/bio-page': {
      id: '/_auth/$orgId/bio-page'
      path: '/bio-page'
      fullPath: '/$orgId/bio-page'
      preLoaderRoute: typeof AuthOrgIdBioPageRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/agency/salons/': {
      id: '/_auth/agency/salons/'
      path: '/salons'
      fullPath: '/agency/salons'
      preLoaderRoute: typeof AuthAgencySalonsIndexRouteImport
      parentRoute: typeof AuthAgencyRoute
    }
    '/_auth/agency/members/': {
      id: '/_auth/agency/members/'
      path: '/'
      fullPath: '/agency/members/'
      preLoaderRoute: typeof AuthAgencyMembersIndexRouteImport
      parentRoute: typeof AuthAgencyMembersRoute
    }
    '/_auth/agency/guidance/': {
      id: '/_auth/agency/guidance/'
      path: '/guidance'
      fullPath: '/agency/guidance'
      preLoaderRoute: typeof AuthAgencyGuidanceIndexRouteImport
      parentRoute: typeof AuthAgencyRoute
    }
    '/_auth/agency/google-business/': {
      id: '/_auth/agency/google-business/'
      path: '/google-business'
      fullPath: '/agency/google-business'
      preLoaderRoute: typeof AuthAgencyGoogleBusinessIndexRouteImport
      parentRoute: typeof AuthAgencyRoute
    }
    '/_auth/agency/ads-doctor/': {
      id: '/_auth/agency/ads-doctor/'
      path: '/ads-doctor'
      fullPath: '/agency/ads-doctor'
      preLoaderRoute: typeof AuthAgencyAdsDoctorIndexRouteImport
      parentRoute: typeof AuthAgencyRoute
    }
    '/_auth/$orgId/settings/': {
      id: '/_auth/$orgId/settings/'
      path: '/settings'
      fullPath: '/$orgId/settings'
      preLoaderRoute: typeof AuthOrgIdSettingsIndexRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/reports/': {
      id: '/_auth/$orgId/reports/'
      path: '/'
      fullPath: '/$orgId/reports/'
      preLoaderRoute: typeof AuthOrgIdReportsIndexRouteImport
      parentRoute: typeof AuthOrgIdReportsRoute
    }
    '/_auth/$orgId/marketing/': {
      id: '/_auth/$orgId/marketing/'
      path: '/'
      fullPath: '/$orgId/marketing/'
      preLoaderRoute: typeof AuthOrgIdMarketingIndexRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/meta/comment-to-dm/callback': {
      id: '/_auth/meta/comment-to-dm/callback'
      path: '/meta/comment-to-dm/callback'
      fullPath: '/meta/comment-to-dm/callback'
      preLoaderRoute: typeof AuthMetaCommentToDmCallbackRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/agency/salons/new': {
      id: '/_auth/agency/salons/new'
      path: '/salons/new'
      fullPath: '/agency/salons/new'
      preLoaderRoute: typeof AuthAgencySalonsNewRouteImport
      parentRoute: typeof AuthAgencyRoute
    }
    '/_auth/agency/salons/$shortCode': {
      id: '/_auth/agency/salons/$shortCode'
      path: '/salons/$shortCode'
      fullPath: '/agency/salons/$shortCode'
      preLoaderRoute: typeof AuthAgencySalonsShortCodeRouteImport
      parentRoute: typeof AuthAgencyRoute
    }
    '/_auth/agency/members/new': {
      id: '/_auth/agency/members/new'
      path: '/new'
      fullPath: '/agency/members/new'
      preLoaderRoute: typeof AuthAgencyMembersNewRouteImport
      parentRoute: typeof AuthAgencyMembersRoute
    }
    '/_auth/agency/members/$memberId': {
      id: '/_auth/agency/members/$memberId'
      path: '/$memberId'
      fullPath: '/agency/members/$memberId'
      preLoaderRoute: typeof AuthAgencyMembersMemberIdRouteImport
      parentRoute: typeof AuthAgencyMembersRoute
    }
    '/_auth/agency/guidance/$slug': {
      id: '/_auth/agency/guidance/$slug'
      path: '/guidance/$slug'
      fullPath: '/agency/guidance/$slug'
      preLoaderRoute: typeof AuthAgencyGuidanceSlugRouteImport
      parentRoute: typeof AuthAgencyRoute
    }
    '/_auth/agency/counter-stands/program': {
      id: '/_auth/agency/counter-stands/program'
      path: '/counter-stands/program'
      fullPath: '/agency/counter-stands/program'
      preLoaderRoute: typeof AuthAgencyCounterStandsProgramRouteImport
      parentRoute: typeof AuthAgencyRoute
    }
    '/_auth/agency/ads-doctor/ask': {
      id: '/_auth/agency/ads-doctor/ask'
      path: '/ads-doctor/ask'
      fullPath: '/agency/ads-doctor/ask'
      preLoaderRoute: typeof AuthAgencyAdsDoctorAskRouteImport
      parentRoute: typeof AuthAgencyRoute
    }
    '/_auth/agency/ads-doctor/$shortCode': {
      id: '/_auth/agency/ads-doctor/$shortCode'
      path: '/ads-doctor/$shortCode'
      fullPath: '/agency/ads-doctor/$shortCode'
      preLoaderRoute: typeof AuthAgencyAdsDoctorShortCodeRouteImport
      parentRoute: typeof AuthAgencyRoute
    }
    '/_auth/$orgId/settings/turn-tracker': {
      id: '/_auth/$orgId/settings/turn-tracker'
      path: '/settings/turn-tracker'
      fullPath: '/$orgId/settings/turn-tracker'
      preLoaderRoute: typeof AuthOrgIdSettingsTurnTrackerRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/staff': {
      id: '/_auth/$orgId/settings/staff'
      path: '/settings/staff'
      fullPath: '/$orgId/settings/staff'
      preLoaderRoute: typeof AuthOrgIdSettingsStaffRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/services': {
      id: '/_auth/$orgId/settings/services'
      path: '/settings/services'
      fullPath: '/$orgId/settings/services'
      preLoaderRoute: typeof AuthOrgIdSettingsServicesRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/plan-and-usage': {
      id: '/_auth/$orgId/settings/plan-and-usage'
      path: '/settings/plan-and-usage'
      fullPath: '/$orgId/settings/plan-and-usage'
      preLoaderRoute: typeof AuthOrgIdSettingsPlanAndUsageRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/marketing-access': {
      id: '/_auth/$orgId/settings/marketing-access'
      path: '/settings/marketing-access'
      fullPath: '/$orgId/settings/marketing-access'
      preLoaderRoute: typeof AuthOrgIdSettingsMarketingAccessRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/link-in-bio': {
      id: '/_auth/$orgId/settings/link-in-bio'
      path: '/settings/link-in-bio'
      fullPath: '/$orgId/settings/link-in-bio'
      preLoaderRoute: typeof AuthOrgIdSettingsLinkInBioRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/integrations': {
      id: '/_auth/$orgId/settings/integrations'
      path: '/settings/integrations'
      fullPath: '/$orgId/settings/integrations'
      preLoaderRoute: typeof AuthOrgIdSettingsIntegrationsRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/check-in': {
      id: '/_auth/$orgId/settings/check-in'
      path: '/settings/check-in'
      fullPath: '/$orgId/settings/check-in'
      preLoaderRoute: typeof AuthOrgIdSettingsCheckInRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/calls': {
      id: '/_auth/$orgId/settings/calls'
      path: '/settings/calls'
      fullPath: '/$orgId/settings/calls'
      preLoaderRoute: typeof AuthOrgIdSettingsCallsRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/appearance': {
      id: '/_auth/$orgId/settings/appearance'
      path: '/settings/appearance'
      fullPath: '/$orgId/settings/appearance'
      preLoaderRoute: typeof AuthOrgIdSettingsAppearanceRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/reports/today': {
      id: '/_auth/$orgId/reports/today'
      path: '/today'
      fullPath: '/$orgId/reports/today'
      preLoaderRoute: typeof AuthOrgIdReportsTodayRouteImport
      parentRoute: typeof AuthOrgIdReportsRoute
    }
    '/_auth/$orgId/reports/team': {
      id: '/_auth/$orgId/reports/team'
      path: '/team'
      fullPath: '/$orgId/reports/team'
      preLoaderRoute: typeof AuthOrgIdReportsTeamRouteImport
      parentRoute: typeof AuthOrgIdReportsRoute
    }
    '/_auth/$orgId/reports/sales': {
      id: '/_auth/$orgId/reports/sales'
      path: '/sales'
      fullPath: '/$orgId/reports/sales'
      preLoaderRoute: typeof AuthOrgIdReportsSalesRouteImport
      parentRoute: typeof AuthOrgIdReportsRoute
    }
    '/_auth/$orgId/reports/reviews': {
      id: '/_auth/$orgId/reports/reviews'
      path: '/reviews'
      fullPath: '/$orgId/reports/reviews'
      preLoaderRoute: typeof AuthOrgIdReportsReviewsRouteImport
      parentRoute: typeof AuthOrgIdReportsRoute
    }
    '/_auth/$orgId/reports/marketing': {
      id: '/_auth/$orgId/reports/marketing'
      path: '/marketing'
      fullPath: '/$orgId/reports/marketing'
      preLoaderRoute: typeof AuthOrgIdReportsMarketingRouteImport
      parentRoute: typeof AuthOrgIdReportsRoute
    }
    '/_auth/$orgId/reports/impact': {
      id: '/_auth/$orgId/reports/impact'
      path: '/impact'
      fullPath: '/$orgId/reports/impact'
      preLoaderRoute: typeof AuthOrgIdReportsImpactRouteImport
      parentRoute: typeof AuthOrgIdReportsRoute
    }
    '/_auth/$orgId/reports/clients': {
      id: '/_auth/$orgId/reports/clients'
      path: '/clients'
      fullPath: '/$orgId/reports/clients'
      preLoaderRoute: typeof AuthOrgIdReportsClientsRouteImport
      parentRoute: typeof AuthOrgIdReportsRoute
    }
    '/_auth/$orgId/reports/appointments': {
      id: '/_auth/$orgId/reports/appointments'
      path: '/appointments'
      fullPath: '/$orgId/reports/appointments'
      preLoaderRoute: typeof AuthOrgIdReportsAppointmentsRouteImport
      parentRoute: typeof AuthOrgIdReportsRoute
    }
    '/_auth/$orgId/marketing/text-keywords': {
      id: '/_auth/$orgId/marketing/text-keywords'
      path: '/text-keywords'
      fullPath: '/$orgId/marketing/text-keywords'
      preLoaderRoute: typeof AuthOrgIdMarketingTextKeywordsRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/settings': {
      id: '/_auth/$orgId/marketing/settings'
      path: '/settings'
      fullPath: '/$orgId/marketing/settings'
      preLoaderRoute: typeof AuthOrgIdMarketingSettingsRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/rewards-card': {
      id: '/_auth/$orgId/marketing/rewards-card'
      path: '/rewards-card'
      fullPath: '/$orgId/marketing/rewards-card'
      preLoaderRoute: typeof AuthOrgIdMarketingRewardsCardRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/reviews': {
      id: '/_auth/$orgId/marketing/reviews'
      path: '/reviews'
      fullPath: '/$orgId/marketing/reviews'
      preLoaderRoute: typeof AuthOrgIdMarketingReviewsRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/referrals': {
      id: '/_auth/$orgId/marketing/referrals'
      path: '/referrals'
      fullPath: '/$orgId/marketing/referrals'
      preLoaderRoute: typeof AuthOrgIdMarketingReferralsRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/qr-codes': {
      id: '/_auth/$orgId/marketing/qr-codes'
      path: '/qr-codes'
      fullPath: '/$orgId/marketing/qr-codes'
      preLoaderRoute: typeof AuthOrgIdMarketingQrCodesRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/prizes': {
      id: '/_auth/$orgId/marketing/prizes'
      path: '/prizes'
      fullPath: '/$orgId/marketing/prizes'
      preLoaderRoute: typeof AuthOrgIdMarketingPrizesRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/owner-report': {
      id: '/_auth/$orgId/marketing/owner-report'
      path: '/owner-report'
      fullPath: '/$orgId/marketing/owner-report'
      preLoaderRoute: typeof AuthOrgIdMarketingOwnerReportRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/new-client-offer': {
      id: '/_auth/$orgId/marketing/new-client-offer'
      path: '/new-client-offer'
      fullPath: '/$orgId/marketing/new-client-offer'
      preLoaderRoute: typeof AuthOrgIdMarketingNewClientOfferRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/listings': {
      id: '/_auth/$orgId/marketing/listings'
      path: '/listings'
      fullPath: '/$orgId/marketing/listings'
      preLoaderRoute: typeof AuthOrgIdMarketingListingsRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/leads': {
      id: '/_auth/$orgId/marketing/leads'
      path: '/leads'
      fullPath: '/$orgId/marketing/leads'
      preLoaderRoute: typeof AuthOrgIdMarketingLeadsRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/hayven-tap': {
      id: '/_auth/$orgId/marketing/hayven-tap'
      path: '/hayven-tap'
      fullPath: '/$orgId/marketing/hayven-tap'
      preLoaderRoute: typeof AuthOrgIdMarketingHayvenTapRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/google-ranking': {
      id: '/_auth/$orgId/marketing/google-ranking'
      path: '/google-ranking'
      fullPath: '/$orgId/marketing/google-ranking'
      preLoaderRoute: typeof AuthOrgIdMarketingGoogleRankingRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/creators': {
      id: '/_auth/$orgId/marketing/creators'
      path: '/creators'
      fullPath: '/$orgId/marketing/creators'
      preLoaderRoute: typeof AuthOrgIdMarketingCreatorsRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/comment-dm': {
      id: '/_auth/$orgId/marketing/comment-dm'
      path: '/comment-dm'
      fullPath: '/$orgId/marketing/comment-dm'
      preLoaderRoute: typeof AuthOrgIdMarketingCommentDmRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/campaigns': {
      id: '/_auth/$orgId/marketing/campaigns'
      path: '/campaigns'
      fullPath: '/$orgId/marketing/campaigns'
      preLoaderRoute: typeof AuthOrgIdMarketingCampaignsRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/bulk-sms': {
      id: '/_auth/$orgId/marketing/bulk-sms'
      path: '/bulk-sms'
      fullPath: '/$orgId/marketing/bulk-sms'
      preLoaderRoute: typeof AuthOrgIdMarketingBulkSmsRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/bio-page': {
      id: '/_auth/$orgId/marketing/bio-page'
      path: '/bio-page'
      fullPath: '/$orgId/marketing/bio-page'
      preLoaderRoute: typeof AuthOrgIdMarketingBioPageRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/analytics': {
      id: '/_auth/$orgId/marketing/analytics'
      path: '/analytics'
      fullPath: '/$orgId/marketing/analytics'
      preLoaderRoute: typeof AuthOrgIdMarketingAnalyticsRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/gift-cards_/settings': {
      id: '/_auth/$orgId/gift-cards_/settings'
      path: '/gift-cards/settings'
      fullPath: '/$orgId/gift-cards/settings'
      preLoaderRoute: typeof AuthOrgIdGiftCardsSettingsRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/marketing/referrals/': {
      id: '/_auth/$orgId/marketing/referrals/'
      path: '/'
      fullPath: '/$orgId/marketing/referrals/'
      preLoaderRoute: typeof AuthOrgIdMarketingReferralsIndexRouteImport
      parentRoute: typeof AuthOrgIdMarketingReferralsRoute
    }
    '/_auth/$orgId/marketing/new-client-offer/': {
      id: '/_auth/$orgId/marketing/new-client-offer/'
      path: '/'
      fullPath: '/$orgId/marketing/new-client-offer/'
      preLoaderRoute: typeof AuthOrgIdMarketingNewClientOfferIndexRouteImport
      parentRoute: typeof AuthOrgIdMarketingNewClientOfferRoute
    }
    '/_auth/$orgId/marketing/google-ranking/': {
      id: '/_auth/$orgId/marketing/google-ranking/'
      path: '/'
      fullPath: '/$orgId/marketing/google-ranking/'
      preLoaderRoute: typeof AuthOrgIdMarketingGoogleRankingIndexRouteImport
      parentRoute: typeof AuthOrgIdMarketingGoogleRankingRoute
    }
    '/_auth/$orgId/settings/services_/same-time': {
      id: '/_auth/$orgId/settings/services_/same-time'
      path: '/settings/services/same-time'
      fullPath: '/$orgId/settings/services/same-time'
      preLoaderRoute: typeof AuthOrgIdSettingsServicesSameTimeRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/services_/import': {
      id: '/_auth/$orgId/settings/services_/import'
      path: '/settings/services/import'
      fullPath: '/$orgId/settings/services/import'
      preLoaderRoute: typeof AuthOrgIdSettingsServicesImportRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/online-booking/staff-selection': {
      id: '/_auth/$orgId/settings/online-booking/staff-selection'
      path: '/settings/online-booking/staff-selection'
      fullPath: '/$orgId/settings/online-booking/staff-selection'
      preLoaderRoute: typeof AuthOrgIdSettingsOnlineBookingStaffSelectionRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/online-booking/setup-integration': {
      id: '/_auth/$orgId/settings/online-booking/setup-integration'
      path: '/settings/online-booking/setup-integration'
      fullPath: '/$orgId/settings/online-booking/setup-integration'
      preLoaderRoute: typeof AuthOrgIdSettingsOnlineBookingSetupIntegrationRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/online-booking/preferences': {
      id: '/_auth/$orgId/settings/online-booking/preferences'
      path: '/settings/online-booking/preferences'
      fullPath: '/$orgId/settings/online-booking/preferences'
      preLoaderRoute: typeof AuthOrgIdSettingsOnlineBookingPreferencesRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/calendar-appointments/scheduling-options': {
      id: '/_auth/$orgId/settings/calendar-appointments/scheduling-options'
      path: '/settings/calendar-appointments/scheduling-options'
      fullPath: '/$orgId/settings/calendar-appointments/scheduling-options'
      preLoaderRoute: typeof AuthOrgIdSettingsCalendarAppointmentsSchedulingOptionsRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/calendar-appointments/no-show-protection': {
      id: '/_auth/$orgId/settings/calendar-appointments/no-show-protection'
      path: '/settings/calendar-appointments/no-show-protection'
      fullPath: '/$orgId/settings/calendar-appointments/no-show-protection'
      preLoaderRoute: typeof AuthOrgIdSettingsCalendarAppointmentsNoShowProtectionRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/calendar-appointments/display-preferences': {
      id: '/_auth/$orgId/settings/calendar-appointments/display-preferences'
      path: '/settings/calendar-appointments/display-preferences'
      fullPath: '/$orgId/settings/calendar-appointments/display-preferences'
      preLoaderRoute: typeof AuthOrgIdSettingsCalendarAppointmentsDisplayPreferencesRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/calendar-appointments/cancel-reschedule': {
      id: '/_auth/$orgId/settings/calendar-appointments/cancel-reschedule'
      path: '/settings/calendar-appointments/cancel-reschedule'
      fullPath: '/$orgId/settings/calendar-appointments/cancel-reschedule'
      preLoaderRoute: typeof AuthOrgIdSettingsCalendarAppointmentsCancelRescheduleRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/business-setup/phone-numbers': {
      id: '/_auth/$orgId/settings/business-setup/phone-numbers'
      path: '/settings/business-setup/phone-numbers'
      fullPath: '/$orgId/settings/business-setup/phone-numbers'
      preLoaderRoute: typeof AuthOrgIdSettingsBusinessSetupPhoneNumbersRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/business-setup/payroll': {
      id: '/_auth/$orgId/settings/business-setup/payroll'
      path: '/settings/business-setup/payroll'
      fullPath: '/$orgId/settings/business-setup/payroll'
      preLoaderRoute: typeof AuthOrgIdSettingsBusinessSetupPayrollRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/business-setup/logo-branding': {
      id: '/_auth/$orgId/settings/business-setup/logo-branding'
      path: '/settings/business-setup/logo-branding'
      fullPath: '/$orgId/settings/business-setup/logo-branding'
      preLoaderRoute: typeof AuthOrgIdSettingsBusinessSetupLogoBrandingRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/business-setup/locations': {
      id: '/_auth/$orgId/settings/business-setup/locations'
      path: '/settings/business-setup/locations'
      fullPath: '/$orgId/settings/business-setup/locations'
      preLoaderRoute: typeof AuthOrgIdSettingsBusinessSetupLocationsRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/business-setup/how-you-use-hayven': {
      id: '/_auth/$orgId/settings/business-setup/how-you-use-hayven'
      path: '/settings/business-setup/how-you-use-hayven'
      fullPath: '/$orgId/settings/business-setup/how-you-use-hayven'
      preLoaderRoute: typeof AuthOrgIdSettingsBusinessSetupHowYouUseHayvenRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/business-setup/business-hours': {
      id: '/_auth/$orgId/settings/business-setup/business-hours'
      path: '/settings/business-setup/business-hours'
      fullPath: '/$orgId/settings/business-setup/business-hours'
      preLoaderRoute: typeof AuthOrgIdSettingsBusinessSetupBusinessHoursRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/business-setup/business-details': {
      id: '/_auth/$orgId/settings/business-setup/business-details'
      path: '/settings/business-setup/business-details'
      fullPath: '/$orgId/settings/business-setup/business-details'
      preLoaderRoute: typeof AuthOrgIdSettingsBusinessSetupBusinessDetailsRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/business-setup/advanced-settings': {
      id: '/_auth/$orgId/settings/business-setup/advanced-settings'
      path: '/settings/business-setup/advanced-settings'
      fullPath: '/$orgId/settings/business-setup/advanced-settings'
      preLoaderRoute: typeof AuthOrgIdSettingsBusinessSetupAdvancedSettingsRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/automated-messages/gift-cards': {
      id: '/_auth/$orgId/settings/automated-messages/gift-cards'
      path: '/settings/automated-messages/gift-cards'
      fullPath: '/$orgId/settings/automated-messages/gift-cards'
      preLoaderRoute: typeof AuthOrgIdSettingsAutomatedMessagesGiftCardsRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/automated-messages/check-in-process': {
      id: '/_auth/$orgId/settings/automated-messages/check-in-process'
      path: '/settings/automated-messages/check-in-process'
      fullPath: '/$orgId/settings/automated-messages/check-in-process'
      preLoaderRoute: typeof AuthOrgIdSettingsAutomatedMessagesCheckInProcessRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/automated-messages/appointment-rescheduled': {
      id: '/_auth/$orgId/settings/automated-messages/appointment-rescheduled'
      path: '/settings/automated-messages/appointment-rescheduled'
      fullPath: '/$orgId/settings/automated-messages/appointment-rescheduled'
      preLoaderRoute: typeof AuthOrgIdSettingsAutomatedMessagesAppointmentRescheduledRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/automated-messages/appointment-completed': {
      id: '/_auth/$orgId/settings/automated-messages/appointment-completed'
      path: '/settings/automated-messages/appointment-completed'
      fullPath: '/$orgId/settings/automated-messages/appointment-completed'
      preLoaderRoute: typeof AuthOrgIdSettingsAutomatedMessagesAppointmentCompletedRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/automated-messages/appointment-cancelled': {
      id: '/_auth/$orgId/settings/automated-messages/appointment-cancelled'
      path: '/settings/automated-messages/appointment-cancelled'
      fullPath: '/$orgId/settings/automated-messages/appointment-cancelled'
      preLoaderRoute: typeof AuthOrgIdSettingsAutomatedMessagesAppointmentCancelledRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/settings/automated-messages/appointment-booked': {
      id: '/_auth/$orgId/settings/automated-messages/appointment-booked'
      path: '/settings/automated-messages/appointment-booked'
      fullPath: '/$orgId/settings/automated-messages/appointment-booked'
      preLoaderRoute: typeof AuthOrgIdSettingsAutomatedMessagesAppointmentBookedRouteImport
      parentRoute: typeof AuthOrgIdRoute
    }
    '/_auth/$orgId/marketing/text-keywords_/$keywordId': {
      id: '/_auth/$orgId/marketing/text-keywords_/$keywordId'
      path: '/text-keywords/$keywordId'
      fullPath: '/$orgId/marketing/text-keywords/$keywordId'
      preLoaderRoute: typeof AuthOrgIdMarketingTextKeywordsKeywordIdRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/reviews_/replies': {
      id: '/_auth/$orgId/marketing/reviews_/replies'
      path: '/reviews/replies'
      fullPath: '/$orgId/marketing/reviews/replies'
      preLoaderRoute: typeof AuthOrgIdMarketingReviewsRepliesRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/referrals/setup': {
      id: '/_auth/$orgId/marketing/referrals/setup'
      path: '/setup'
      fullPath: '/$orgId/marketing/referrals/setup'
      preLoaderRoute: typeof AuthOrgIdMarketingReferralsSetupRouteImport
      parentRoute: typeof AuthOrgIdMarketingReferralsRoute
    }
    '/_auth/$orgId/marketing/new-client-offer/setup': {
      id: '/_auth/$orgId/marketing/new-client-offer/setup'
      path: '/setup'
      fullPath: '/$orgId/marketing/new-client-offer/setup'
      preLoaderRoute: typeof AuthOrgIdMarketingNewClientOfferSetupRouteImport
      parentRoute: typeof AuthOrgIdMarketingNewClientOfferRoute
    }
    '/_auth/$orgId/marketing/new-client-offer/guests': {
      id: '/_auth/$orgId/marketing/new-client-offer/guests'
      path: '/guests'
      fullPath: '/$orgId/marketing/new-client-offer/guests'
      preLoaderRoute: typeof AuthOrgIdMarketingNewClientOfferGuestsRouteImport
      parentRoute: typeof AuthOrgIdMarketingNewClientOfferRoute
    }
    '/_auth/$orgId/marketing/google-ranking_/photos': {
      id: '/_auth/$orgId/marketing/google-ranking_/photos'
      path: '/google-ranking/photos'
      fullPath: '/$orgId/marketing/google-ranking/photos'
      preLoaderRoute: typeof AuthOrgIdMarketingGoogleRankingPhotosRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/google-ranking/profile': {
      id: '/_auth/$orgId/marketing/google-ranking/profile'
      path: '/profile'
      fullPath: '/$orgId/marketing/google-ranking/profile'
      preLoaderRoute: typeof AuthOrgIdMarketingGoogleRankingProfileRouteImport
      parentRoute: typeof AuthOrgIdMarketingGoogleRankingRoute
    }
    '/_auth/$orgId/marketing/google-ranking/posts': {
      id: '/_auth/$orgId/marketing/google-ranking/posts'
      path: '/posts'
      fullPath: '/$orgId/marketing/google-ranking/posts'
      preLoaderRoute: typeof AuthOrgIdMarketingGoogleRankingPostsRouteImport
      parentRoute: typeof AuthOrgIdMarketingGoogleRankingRoute
    }
    '/_auth/$orgId/marketing/creators_/$creatorId': {
      id: '/_auth/$orgId/marketing/creators_/$creatorId'
      path: '/creators/$creatorId'
      fullPath: '/$orgId/marketing/creators/$creatorId'
      preLoaderRoute: typeof AuthOrgIdMarketingCreatorsCreatorIdRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/comment-dm_/new': {
      id: '/_auth/$orgId/marketing/comment-dm_/new'
      path: '/comment-dm/new'
      fullPath: '/$orgId/marketing/comment-dm/new'
      preLoaderRoute: typeof AuthOrgIdMarketingCommentDmNewRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/comment-dm_/auto-reply': {
      id: '/_auth/$orgId/marketing/comment-dm_/auto-reply'
      path: '/comment-dm/auto-reply'
      fullPath: '/$orgId/marketing/comment-dm/auto-reply'
      preLoaderRoute: typeof AuthOrgIdMarketingCommentDmAutoReplyRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/comment-dm_/$automationId': {
      id: '/_auth/$orgId/marketing/comment-dm_/$automationId'
      path: '/comment-dm/$automationId'
      fullPath: '/$orgId/marketing/comment-dm/$automationId'
      preLoaderRoute: typeof AuthOrgIdMarketingCommentDmAutomationIdRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/campaigns_/new': {
      id: '/_auth/$orgId/marketing/campaigns_/new'
      path: '/campaigns/new'
      fullPath: '/$orgId/marketing/campaigns/new'
      preLoaderRoute: typeof AuthOrgIdMarketingCampaignsNewRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/campaigns_/$campaignId': {
      id: '/_auth/$orgId/marketing/campaigns_/$campaignId'
      path: '/campaigns/$campaignId'
      fullPath: '/$orgId/marketing/campaigns/$campaignId'
      preLoaderRoute: typeof AuthOrgIdMarketingCampaignsCampaignIdRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/bulk-sms_/$bulkSendId': {
      id: '/_auth/$orgId/marketing/bulk-sms_/$bulkSendId'
      path: '/bulk-sms/$bulkSendId'
      fullPath: '/$orgId/marketing/bulk-sms/$bulkSendId'
      preLoaderRoute: typeof AuthOrgIdMarketingBulkSmsBulkSendIdRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/campaigns_/new_/voucher': {
      id: '/_auth/$orgId/marketing/campaigns_/new_/voucher'
      path: '/campaigns/new/voucher'
      fullPath: '/$orgId/marketing/campaigns/new/voucher'
      preLoaderRoute: typeof AuthOrgIdMarketingCampaignsNewVoucherRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/campaigns_/new_/giveaway': {
      id: '/_auth/$orgId/marketing/campaigns_/new_/giveaway'
      path: '/campaigns/new/giveaway'
      fullPath: '/$orgId/marketing/campaigns/new/giveaway'
      preLoaderRoute: typeof AuthOrgIdMarketingCampaignsNewGiveawayRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/campaigns_/new_/flyer-page': {
      id: '/_auth/$orgId/marketing/campaigns_/new_/flyer-page'
      path: '/campaigns/new/flyer-page'
      fullPath: '/$orgId/marketing/campaigns/new/flyer-page'
      preLoaderRoute: typeof AuthOrgIdMarketingCampaignsNewFlyerPageRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/campaigns_/new_/event': {
      id: '/_auth/$orgId/marketing/campaigns_/new_/event'
      path: '/campaigns/new/event'
      fullPath: '/$orgId/marketing/campaigns/new/event'
      preLoaderRoute: typeof AuthOrgIdMarketingCampaignsNewEventRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/campaigns_/$campaignId_/voucher': {
      id: '/_auth/$orgId/marketing/campaigns_/$campaignId_/voucher'
      path: '/campaigns/$campaignId/voucher'
      fullPath: '/$orgId/marketing/campaigns/$campaignId/voucher'
      preLoaderRoute: typeof AuthOrgIdMarketingCampaignsCampaignIdVoucherRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/campaigns_/$campaignId_/review': {
      id: '/_auth/$orgId/marketing/campaigns_/$campaignId_/review'
      path: '/campaigns/$campaignId/review'
      fullPath: '/$orgId/marketing/campaigns/$campaignId/review'
      preLoaderRoute: typeof AuthOrgIdMarketingCampaignsCampaignIdReviewRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/campaigns_/$campaignId_/published': {
      id: '/_auth/$orgId/marketing/campaigns_/$campaignId_/published'
      path: '/campaigns/$campaignId/published'
      fullPath: '/$orgId/marketing/campaigns/$campaignId/published'
      preLoaderRoute: typeof AuthOrgIdMarketingCampaignsCampaignIdPublishedRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/campaigns_/$campaignId_/landing': {
      id: '/_auth/$orgId/marketing/campaigns_/$campaignId_/landing'
      path: '/campaigns/$campaignId/landing'
      fullPath: '/$orgId/marketing/campaigns/$campaignId/landing'
      preLoaderRoute: typeof AuthOrgIdMarketingCampaignsCampaignIdLandingRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/campaigns_/$campaignId_/giveaway': {
      id: '/_auth/$orgId/marketing/campaigns_/$campaignId_/giveaway'
      path: '/campaigns/$campaignId/giveaway'
      fullPath: '/$orgId/marketing/campaigns/$campaignId/giveaway'
      preLoaderRoute: typeof AuthOrgIdMarketingCampaignsCampaignIdGiveawayRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/campaigns_/$campaignId_/automations': {
      id: '/_auth/$orgId/marketing/campaigns_/$campaignId_/automations'
      path: '/campaigns/$campaignId/automations'
      fullPath: '/$orgId/marketing/campaigns/$campaignId/automations'
      preLoaderRoute: typeof AuthOrgIdMarketingCampaignsCampaignIdAutomationsRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
    '/_auth/$orgId/marketing/campaigns_/$campaignId_/giveaway_/live': {
      id: '/_auth/$orgId/marketing/campaigns_/$campaignId_/giveaway_/live'
      path: '/campaigns/$campaignId/giveaway/live'
      fullPath: '/$orgId/marketing/campaigns/$campaignId/giveaway/live'
      preLoaderRoute: typeof AuthOrgIdMarketingCampaignsCampaignIdGiveawayLiveRouteImport
      parentRoute: typeof AuthOrgIdMarketingRoute
    }
  }
}

interface AuthOrgIdMarketingGoogleRankingRouteChildren {
  AuthOrgIdMarketingGoogleRankingPostsRoute: typeof AuthOrgIdMarketingGoogleRankingPostsRoute
  AuthOrgIdMarketingGoogleRankingProfileRoute: typeof AuthOrgIdMarketingGoogleRankingProfileRoute
  AuthOrgIdMarketingGoogleRankingIndexRoute: typeof AuthOrgIdMarketingGoogleRankingIndexRoute
}

const AuthOrgIdMarketingGoogleRankingRouteChildren: AuthOrgIdMarketingGoogleRankingRouteChildren =
  {
    AuthOrgIdMarketingGoogleRankingPostsRoute:
      AuthOrgIdMarketingGoogleRankingPostsRoute,
    AuthOrgIdMarketingGoogleRankingProfileRoute:
      AuthOrgIdMarketingGoogleRankingProfileRoute,
    AuthOrgIdMarketingGoogleRankingIndexRoute:
      AuthOrgIdMarketingGoogleRankingIndexRoute,
  }

const AuthOrgIdMarketingGoogleRankingRouteWithChildren =
  AuthOrgIdMarketingGoogleRankingRoute._addFileChildren(
    AuthOrgIdMarketingGoogleRankingRouteChildren,
  )

interface AuthOrgIdMarketingNewClientOfferRouteChildren {
  AuthOrgIdMarketingNewClientOfferGuestsRoute: typeof AuthOrgIdMarketingNewClientOfferGuestsRoute
  AuthOrgIdMarketingNewClientOfferSetupRoute: typeof AuthOrgIdMarketingNewClientOfferSetupRoute
  AuthOrgIdMarketingNewClientOfferIndexRoute: typeof AuthOrgIdMarketingNewClientOfferIndexRoute
}

const AuthOrgIdMarketingNewClientOfferRouteChildren: AuthOrgIdMarketingNewClientOfferRouteChildren =
  {
    AuthOrgIdMarketingNewClientOfferGuestsRoute:
      AuthOrgIdMarketingNewClientOfferGuestsRoute,
    AuthOrgIdMarketingNewClientOfferSetupRoute:
      AuthOrgIdMarketingNewClientOfferSetupRoute,
    AuthOrgIdMarketingNewClientOfferIndexRoute:
      AuthOrgIdMarketingNewClientOfferIndexRoute,
  }

const AuthOrgIdMarketingNewClientOfferRouteWithChildren =
  AuthOrgIdMarketingNewClientOfferRoute._addFileChildren(
    AuthOrgIdMarketingNewClientOfferRouteChildren,
  )

interface AuthOrgIdMarketingReferralsRouteChildren {
  AuthOrgIdMarketingReferralsSetupRoute: typeof AuthOrgIdMarketingReferralsSetupRoute
  AuthOrgIdMarketingReferralsIndexRoute: typeof AuthOrgIdMarketingReferralsIndexRoute
}

const AuthOrgIdMarketingReferralsRouteChildren: AuthOrgIdMarketingReferralsRouteChildren =
  {
    AuthOrgIdMarketingReferralsSetupRoute:
      AuthOrgIdMarketingReferralsSetupRoute,
    AuthOrgIdMarketingReferralsIndexRoute:
      AuthOrgIdMarketingReferralsIndexRoute,
  }

const AuthOrgIdMarketingReferralsRouteWithChildren =
  AuthOrgIdMarketingReferralsRoute._addFileChildren(
    AuthOrgIdMarketingReferralsRouteChildren,
  )

interface AuthOrgIdMarketingRouteChildren {
  AuthOrgIdMarketingAnalyticsRoute: typeof AuthOrgIdMarketingAnalyticsRoute
  AuthOrgIdMarketingBioPageRoute: typeof AuthOrgIdMarketingBioPageRoute
  AuthOrgIdMarketingBulkSmsRoute: typeof AuthOrgIdMarketingBulkSmsRoute
  AuthOrgIdMarketingCampaignsRoute: typeof AuthOrgIdMarketingCampaignsRoute
  AuthOrgIdMarketingCommentDmRoute: typeof AuthOrgIdMarketingCommentDmRoute
  AuthOrgIdMarketingCreatorsRoute: typeof AuthOrgIdMarketingCreatorsRoute
  AuthOrgIdMarketingGoogleRankingRoute: typeof AuthOrgIdMarketingGoogleRankingRouteWithChildren
  AuthOrgIdMarketingHayvenTapRoute: typeof AuthOrgIdMarketingHayvenTapRoute
  AuthOrgIdMarketingLeadsRoute: typeof AuthOrgIdMarketingLeadsRoute
  AuthOrgIdMarketingListingsRoute: typeof AuthOrgIdMarketingListingsRoute
  AuthOrgIdMarketingNewClientOfferRoute: typeof AuthOrgIdMarketingNewClientOfferRouteWithChildren
  AuthOrgIdMarketingOwnerReportRoute: typeof AuthOrgIdMarketingOwnerReportRoute
  AuthOrgIdMarketingPrizesRoute: typeof AuthOrgIdMarketingPrizesRoute
  AuthOrgIdMarketingQrCodesRoute: typeof AuthOrgIdMarketingQrCodesRoute
  AuthOrgIdMarketingReferralsRoute: typeof AuthOrgIdMarketingReferralsRouteWithChildren
  AuthOrgIdMarketingReviewsRoute: typeof AuthOrgIdMarketingReviewsRoute
  AuthOrgIdMarketingRewardsCardRoute: typeof AuthOrgIdMarketingRewardsCardRoute
  AuthOrgIdMarketingSettingsRoute: typeof AuthOrgIdMarketingSettingsRoute
  AuthOrgIdMarketingTextKeywordsRoute: typeof AuthOrgIdMarketingTextKeywordsRoute
  AuthOrgIdMarketingIndexRoute: typeof AuthOrgIdMarketingIndexRoute
  AuthOrgIdMarketingBulkSmsBulkSendIdRoute: typeof AuthOrgIdMarketingBulkSmsBulkSendIdRoute
  AuthOrgIdMarketingCampaignsCampaignIdRoute: typeof AuthOrgIdMarketingCampaignsCampaignIdRoute
  AuthOrgIdMarketingCampaignsNewRoute: typeof AuthOrgIdMarketingCampaignsNewRoute
  AuthOrgIdMarketingCommentDmAutomationIdRoute: typeof AuthOrgIdMarketingCommentDmAutomationIdRoute
  AuthOrgIdMarketingCommentDmAutoReplyRoute: typeof AuthOrgIdMarketingCommentDmAutoReplyRoute
  AuthOrgIdMarketingCommentDmNewRoute: typeof AuthOrgIdMarketingCommentDmNewRoute
  AuthOrgIdMarketingCreatorsCreatorIdRoute: typeof AuthOrgIdMarketingCreatorsCreatorIdRoute
  AuthOrgIdMarketingGoogleRankingPhotosRoute: typeof AuthOrgIdMarketingGoogleRankingPhotosRoute
  AuthOrgIdMarketingReviewsRepliesRoute: typeof AuthOrgIdMarketingReviewsRepliesRoute
  AuthOrgIdMarketingTextKeywordsKeywordIdRoute: typeof AuthOrgIdMarketingTextKeywordsKeywordIdRoute
  AuthOrgIdMarketingCampaignsCampaignIdAutomationsRoute: typeof AuthOrgIdMarketingCampaignsCampaignIdAutomationsRoute
  AuthOrgIdMarketingCampaignsCampaignIdGiveawayRoute: typeof AuthOrgIdMarketingCampaignsCampaignIdGiveawayRoute
  AuthOrgIdMarketingCampaignsCampaignIdLandingRoute: typeof AuthOrgIdMarketingCampaignsCampaignIdLandingRoute
  AuthOrgIdMarketingCampaignsCampaignIdPublishedRoute: typeof AuthOrgIdMarketingCampaignsCampaignIdPublishedRoute
  AuthOrgIdMarketingCampaignsCampaignIdReviewRoute: typeof AuthOrgIdMarketingCampaignsCampaignIdReviewRoute
  AuthOrgIdMarketingCampaignsCampaignIdVoucherRoute: typeof AuthOrgIdMarketingCampaignsCampaignIdVoucherRoute
  AuthOrgIdMarketingCampaignsNewEventRoute: typeof AuthOrgIdMarketingCampaignsNewEventRoute
  AuthOrgIdMarketingCampaignsNewFlyerPageRoute: typeof AuthOrgIdMarketingCampaignsNewFlyerPageRoute
  AuthOrgIdMarketingCampaignsNewGiveawayRoute: typeof AuthOrgIdMarketingCampaignsNewGiveawayRoute
  AuthOrgIdMarketingCampaignsNewVoucherRoute: typeof AuthOrgIdMarketingCampaignsNewVoucherRoute
  AuthOrgIdMarketingCampaignsCampaignIdGiveawayLiveRoute: typeof AuthOrgIdMarketingCampaignsCampaignIdGiveawayLiveRoute
}

const AuthOrgIdMarketingRouteChildren: AuthOrgIdMarketingRouteChildren = {
  AuthOrgIdMarketingAnalyticsRoute: AuthOrgIdMarketingAnalyticsRoute,
  AuthOrgIdMarketingBioPageRoute: AuthOrgIdMarketingBioPageRoute,
  AuthOrgIdMarketingBulkSmsRoute: AuthOrgIdMarketingBulkSmsRoute,
  AuthOrgIdMarketingCampaignsRoute: AuthOrgIdMarketingCampaignsRoute,
  AuthOrgIdMarketingCommentDmRoute: AuthOrgIdMarketingCommentDmRoute,
  AuthOrgIdMarketingCreatorsRoute: AuthOrgIdMarketingCreatorsRoute,
  AuthOrgIdMarketingGoogleRankingRoute:
    AuthOrgIdMarketingGoogleRankingRouteWithChildren,
  AuthOrgIdMarketingHayvenTapRoute: AuthOrgIdMarketingHayvenTapRoute,
  AuthOrgIdMarketingLeadsRoute: AuthOrgIdMarketingLeadsRoute,
  AuthOrgIdMarketingListingsRoute: AuthOrgIdMarketingListingsRoute,
  AuthOrgIdMarketingNewClientOfferRoute:
    AuthOrgIdMarketingNewClientOfferRouteWithChildren,
  AuthOrgIdMarketingOwnerReportRoute: AuthOrgIdMarketingOwnerReportRoute,
  AuthOrgIdMarketingPrizesRoute: AuthOrgIdMarketingPrizesRoute,
  AuthOrgIdMarketingQrCodesRoute: AuthOrgIdMarketingQrCodesRoute,
  AuthOrgIdMarketingReferralsRoute:
    AuthOrgIdMarketingReferralsRouteWithChildren,
  AuthOrgIdMarketingReviewsRoute: AuthOrgIdMarketingReviewsRoute,
  AuthOrgIdMarketingRewardsCardRoute: AuthOrgIdMarketingRewardsCardRoute,
  AuthOrgIdMarketingSettingsRoute: AuthOrgIdMarketingSettingsRoute,
  AuthOrgIdMarketingTextKeywordsRoute: AuthOrgIdMarketingTextKeywordsRoute,
  AuthOrgIdMarketingIndexRoute: AuthOrgIdMarketingIndexRoute,
  AuthOrgIdMarketingBulkSmsBulkSendIdRoute:
    AuthOrgIdMarketingBulkSmsBulkSendIdRoute,
  AuthOrgIdMarketingCampaignsCampaignIdRoute:
    AuthOrgIdMarketingCampaignsCampaignIdRoute,
  AuthOrgIdMarketingCampaignsNewRoute: AuthOrgIdMarketingCampaignsNewRoute,
  AuthOrgIdMarketingCommentDmAutomationIdRoute:
    AuthOrgIdMarketingCommentDmAutomationIdRoute,
  AuthOrgIdMarketingCommentDmAutoReplyRoute:
    AuthOrgIdMarketingCommentDmAutoReplyRoute,
  AuthOrgIdMarketingCommentDmNewRoute: AuthOrgIdMarketingCommentDmNewRoute,
  AuthOrgIdMarketingCreatorsCreatorIdRoute:
    AuthOrgIdMarketingCreatorsCreatorIdRoute,
  AuthOrgIdMarketingGoogleRankingPhotosRoute:
    AuthOrgIdMarketingGoogleRankingPhotosRoute,
  AuthOrgIdMarketingReviewsRepliesRoute: AuthOrgIdMarketingReviewsRepliesRoute,
  AuthOrgIdMarketingTextKeywordsKeywordIdRoute:
    AuthOrgIdMarketingTextKeywordsKeywordIdRoute,
  AuthOrgIdMarketingCampaignsCampaignIdAutomationsRoute:
    AuthOrgIdMarketingCampaignsCampaignIdAutomationsRoute,
  AuthOrgIdMarketingCampaignsCampaignIdGiveawayRoute:
    AuthOrgIdMarketingCampaignsCampaignIdGiveawayRoute,
  AuthOrgIdMarketingCampaignsCampaignIdLandingRoute:
    AuthOrgIdMarketingCampaignsCampaignIdLandingRoute,
  AuthOrgIdMarketingCampaignsCampaignIdPublishedRoute:
    AuthOrgIdMarketingCampaignsCampaignIdPublishedRoute,
  AuthOrgIdMarketingCampaignsCampaignIdReviewRoute:
    AuthOrgIdMarketingCampaignsCampaignIdReviewRoute,
  AuthOrgIdMarketingCampaignsCampaignIdVoucherRoute:
    AuthOrgIdMarketingCampaignsCampaignIdVoucherRoute,
  AuthOrgIdMarketingCampaignsNewEventRoute:
    AuthOrgIdMarketingCampaignsNewEventRoute,
  AuthOrgIdMarketingCampaignsNewFlyerPageRoute:
    AuthOrgIdMarketingCampaignsNewFlyerPageRoute,
  AuthOrgIdMarketingCampaignsNewGiveawayRoute:
    AuthOrgIdMarketingCampaignsNewGiveawayRoute,
  AuthOrgIdMarketingCampaignsNewVoucherRoute:
    AuthOrgIdMarketingCampaignsNewVoucherRoute,
  AuthOrgIdMarketingCampaignsCampaignIdGiveawayLiveRoute:
    AuthOrgIdMarketingCampaignsCampaignIdGiveawayLiveRoute,
}

const AuthOrgIdMarketingRouteWithChildren =
  AuthOrgIdMarketingRoute._addFileChildren(AuthOrgIdMarketingRouteChildren)

interface AuthOrgIdReportsRouteChildren {
  AuthOrgIdReportsAppointmentsRoute: typeof AuthOrgIdReportsAppointmentsRoute
  AuthOrgIdReportsClientsRoute: typeof AuthOrgIdReportsClientsRoute
  AuthOrgIdReportsImpactRoute: typeof AuthOrgIdReportsImpactRoute
  AuthOrgIdReportsMarketingRoute: typeof AuthOrgIdReportsMarketingRoute
  AuthOrgIdReportsReviewsRoute: typeof AuthOrgIdReportsReviewsRoute
  AuthOrgIdReportsSalesRoute: typeof AuthOrgIdReportsSalesRoute
  AuthOrgIdReportsTeamRoute: typeof AuthOrgIdReportsTeamRoute
  AuthOrgIdReportsTodayRoute: typeof AuthOrgIdReportsTodayRoute
  AuthOrgIdReportsIndexRoute: typeof AuthOrgIdReportsIndexRoute
}

const AuthOrgIdReportsRouteChildren: AuthOrgIdReportsRouteChildren = {
  AuthOrgIdReportsAppointmentsRoute: AuthOrgIdReportsAppointmentsRoute,
  AuthOrgIdReportsClientsRoute: AuthOrgIdReportsClientsRoute,
  AuthOrgIdReportsImpactRoute: AuthOrgIdReportsImpactRoute,
  AuthOrgIdReportsMarketingRoute: AuthOrgIdReportsMarketingRoute,
  AuthOrgIdReportsReviewsRoute: AuthOrgIdReportsReviewsRoute,
  AuthOrgIdReportsSalesRoute: AuthOrgIdReportsSalesRoute,
  AuthOrgIdReportsTeamRoute: AuthOrgIdReportsTeamRoute,
  AuthOrgIdReportsTodayRoute: AuthOrgIdReportsTodayRoute,
  AuthOrgIdReportsIndexRoute: AuthOrgIdReportsIndexRoute,
}

const AuthOrgIdReportsRouteWithChildren =
  AuthOrgIdReportsRoute._addFileChildren(AuthOrgIdReportsRouteChildren)

interface AuthOrgIdRouteChildren {
  AuthOrgIdBioPageRoute: typeof AuthOrgIdBioPageRoute
  AuthOrgIdCalendarRoute: typeof AuthOrgIdCalendarRoute
  AuthOrgIdClientsRoute: typeof AuthOrgIdClientsRoute
  AuthOrgIdGetStartedRoute: typeof AuthOrgIdGetStartedRoute
  AuthOrgIdGiftCardsRoute: typeof AuthOrgIdGiftCardsRoute
  AuthOrgIdInboxRoute: typeof AuthOrgIdInboxRoute
  AuthOrgIdMarketingRoute: typeof AuthOrgIdMarketingRouteWithChildren
  AuthOrgIdProductsRoute: typeof AuthOrgIdProductsRoute
  AuthOrgIdReportsRoute: typeof AuthOrgIdReportsRouteWithChildren
  AuthOrgIdSalesRoute: typeof AuthOrgIdSalesRoute
  AuthOrgIdTurnTrackerRoute: typeof AuthOrgIdTurnTrackerRoute
  AuthOrgIdUserSettingsRoute: typeof AuthOrgIdUserSettingsRoute
  AuthOrgIdIndexRoute: typeof AuthOrgIdIndexRoute
  AuthOrgIdGiftCardsSettingsRoute: typeof AuthOrgIdGiftCardsSettingsRoute
  AuthOrgIdSettingsAppearanceRoute: typeof AuthOrgIdSettingsAppearanceRoute
  AuthOrgIdSettingsCallsRoute: typeof AuthOrgIdSettingsCallsRoute
  AuthOrgIdSettingsCheckInRoute: typeof AuthOrgIdSettingsCheckInRoute
  AuthOrgIdSettingsIntegrationsRoute: typeof AuthOrgIdSettingsIntegrationsRoute
  AuthOrgIdSettingsLinkInBioRoute: typeof AuthOrgIdSettingsLinkInBioRoute
  AuthOrgIdSettingsMarketingAccessRoute: typeof AuthOrgIdSettingsMarketingAccessRoute
  AuthOrgIdSettingsPlanAndUsageRoute: typeof AuthOrgIdSettingsPlanAndUsageRoute
  AuthOrgIdSettingsServicesRoute: typeof AuthOrgIdSettingsServicesRoute
  AuthOrgIdSettingsStaffRoute: typeof AuthOrgIdSettingsStaffRoute
  AuthOrgIdSettingsTurnTrackerRoute: typeof AuthOrgIdSettingsTurnTrackerRoute
  AuthOrgIdSettingsIndexRoute: typeof AuthOrgIdSettingsIndexRoute
  AuthOrgIdSettingsAutomatedMessagesAppointmentBookedRoute: typeof AuthOrgIdSettingsAutomatedMessagesAppointmentBookedRoute
  AuthOrgIdSettingsAutomatedMessagesAppointmentCancelledRoute: typeof AuthOrgIdSettingsAutomatedMessagesAppointmentCancelledRoute
  AuthOrgIdSettingsAutomatedMessagesAppointmentCompletedRoute: typeof AuthOrgIdSettingsAutomatedMessagesAppointmentCompletedRoute
  AuthOrgIdSettingsAutomatedMessagesAppointmentRescheduledRoute: typeof AuthOrgIdSettingsAutomatedMessagesAppointmentRescheduledRoute
  AuthOrgIdSettingsAutomatedMessagesCheckInProcessRoute: typeof AuthOrgIdSettingsAutomatedMessagesCheckInProcessRoute
  AuthOrgIdSettingsAutomatedMessagesGiftCardsRoute: typeof AuthOrgIdSettingsAutomatedMessagesGiftCardsRoute
  AuthOrgIdSettingsBusinessSetupAdvancedSettingsRoute: typeof AuthOrgIdSettingsBusinessSetupAdvancedSettingsRoute
  AuthOrgIdSettingsBusinessSetupBusinessDetailsRoute: typeof AuthOrgIdSettingsBusinessSetupBusinessDetailsRoute
  AuthOrgIdSettingsBusinessSetupBusinessHoursRoute: typeof AuthOrgIdSettingsBusinessSetupBusinessHoursRoute
  AuthOrgIdSettingsBusinessSetupHowYouUseHayvenRoute: typeof AuthOrgIdSettingsBusinessSetupHowYouUseHayvenRoute
  AuthOrgIdSettingsBusinessSetupLocationsRoute: typeof AuthOrgIdSettingsBusinessSetupLocationsRoute
  AuthOrgIdSettingsBusinessSetupLogoBrandingRoute: typeof AuthOrgIdSettingsBusinessSetupLogoBrandingRoute
  AuthOrgIdSettingsBusinessSetupPayrollRoute: typeof AuthOrgIdSettingsBusinessSetupPayrollRoute
  AuthOrgIdSettingsBusinessSetupPhoneNumbersRoute: typeof AuthOrgIdSettingsBusinessSetupPhoneNumbersRoute
  AuthOrgIdSettingsCalendarAppointmentsCancelRescheduleRoute: typeof AuthOrgIdSettingsCalendarAppointmentsCancelRescheduleRoute
  AuthOrgIdSettingsCalendarAppointmentsDisplayPreferencesRoute: typeof AuthOrgIdSettingsCalendarAppointmentsDisplayPreferencesRoute
  AuthOrgIdSettingsCalendarAppointmentsNoShowProtectionRoute: typeof AuthOrgIdSettingsCalendarAppointmentsNoShowProtectionRoute
  AuthOrgIdSettingsCalendarAppointmentsSchedulingOptionsRoute: typeof AuthOrgIdSettingsCalendarAppointmentsSchedulingOptionsRoute
  AuthOrgIdSettingsOnlineBookingPreferencesRoute: typeof AuthOrgIdSettingsOnlineBookingPreferencesRoute
  AuthOrgIdSettingsOnlineBookingSetupIntegrationRoute: typeof AuthOrgIdSettingsOnlineBookingSetupIntegrationRoute
  AuthOrgIdSettingsOnlineBookingStaffSelectionRoute: typeof AuthOrgIdSettingsOnlineBookingStaffSelectionRoute
  AuthOrgIdSettingsServicesImportRoute: typeof AuthOrgIdSettingsServicesImportRoute
  AuthOrgIdSettingsServicesSameTimeRoute: typeof AuthOrgIdSettingsServicesSameTimeRoute
}

const AuthOrgIdRouteChildren: AuthOrgIdRouteChildren = {
  AuthOrgIdBioPageRoute: AuthOrgIdBioPageRoute,
  AuthOrgIdCalendarRoute: AuthOrgIdCalendarRoute,
  AuthOrgIdClientsRoute: AuthOrgIdClientsRoute,
  AuthOrgIdGetStartedRoute: AuthOrgIdGetStartedRoute,
  AuthOrgIdGiftCardsRoute: AuthOrgIdGiftCardsRoute,
  AuthOrgIdInboxRoute: AuthOrgIdInboxRoute,
  AuthOrgIdMarketingRoute: AuthOrgIdMarketingRouteWithChildren,
  AuthOrgIdProductsRoute: AuthOrgIdProductsRoute,
  AuthOrgIdReportsRoute: AuthOrgIdReportsRouteWithChildren,
  AuthOrgIdSalesRoute: AuthOrgIdSalesRoute,
  AuthOrgIdTurnTrackerRoute: AuthOrgIdTurnTrackerRoute,
  AuthOrgIdUserSettingsRoute: AuthOrgIdUserSettingsRoute,
  AuthOrgIdIndexRoute: AuthOrgIdIndexRoute,
  AuthOrgIdGiftCardsSettingsRoute: AuthOrgIdGiftCardsSettingsRoute,
  AuthOrgIdSettingsAppearanceRoute: AuthOrgIdSettingsAppearanceRoute,
  AuthOrgIdSettingsCallsRoute: AuthOrgIdSettingsCallsRoute,
  AuthOrgIdSettingsCheckInRoute: AuthOrgIdSettingsCheckInRoute,
  AuthOrgIdSettingsIntegrationsRoute: AuthOrgIdSettingsIntegrationsRoute,
  AuthOrgIdSettingsLinkInBioRoute: AuthOrgIdSettingsLinkInBioRoute,
  AuthOrgIdSettingsMarketingAccessRoute: AuthOrgIdSettingsMarketingAccessRoute,
  AuthOrgIdSettingsPlanAndUsageRoute: AuthOrgIdSettingsPlanAndUsageRoute,
  AuthOrgIdSettingsServicesRoute: AuthOrgIdSettingsServicesRoute,
  AuthOrgIdSettingsStaffRoute: AuthOrgIdSettingsStaffRoute,
  AuthOrgIdSettingsTurnTrackerRoute: AuthOrgIdSettingsTurnTrackerRoute,
  AuthOrgIdSettingsIndexRoute: AuthOrgIdSettingsIndexRoute,
  AuthOrgIdSettingsAutomatedMessagesAppointmentBookedRoute:
    AuthOrgIdSettingsAutomatedMessagesAppointmentBookedRoute,
  AuthOrgIdSettingsAutomatedMessagesAppointmentCancelledRoute:
    AuthOrgIdSettingsAutomatedMessagesAppointmentCancelledRoute,
  AuthOrgIdSettingsAutomatedMessagesAppointmentCompletedRoute:
    AuthOrgIdSettingsAutomatedMessagesAppointmentCompletedRoute,
  AuthOrgIdSettingsAutomatedMessagesAppointmentRescheduledRoute:
    AuthOrgIdSettingsAutomatedMessagesAppointmentRescheduledRoute,
  AuthOrgIdSettingsAutomatedMessagesCheckInProcessRoute:
    AuthOrgIdSettingsAutomatedMessagesCheckInProcessRoute,
  AuthOrgIdSettingsAutomatedMessagesGiftCardsRoute:
    AuthOrgIdSettingsAutomatedMessagesGiftCardsRoute,
  AuthOrgIdSettingsBusinessSetupAdvancedSettingsRoute:
    AuthOrgIdSettingsBusinessSetupAdvancedSettingsRoute,
  AuthOrgIdSettingsBusinessSetupBusinessDetailsRoute:
    AuthOrgIdSettingsBusinessSetupBusinessDetailsRoute,
  AuthOrgIdSettingsBusinessSetupBusinessHoursRoute:
    AuthOrgIdSettingsBusinessSetupBusinessHoursRoute,
  AuthOrgIdSettingsBusinessSetupHowYouUseHayvenRoute:
    AuthOrgIdSettingsBusinessSetupHowYouUseHayvenRoute,
  AuthOrgIdSettingsBusinessSetupLocationsRoute:
    AuthOrgIdSettingsBusinessSetupLocationsRoute,
  AuthOrgIdSettingsBusinessSetupLogoBrandingRoute:
    AuthOrgIdSettingsBusinessSetupLogoBrandingRoute,
  AuthOrgIdSettingsBusinessSetupPayrollRoute:
    AuthOrgIdSettingsBusinessSetupPayrollRoute,
  AuthOrgIdSettingsBusinessSetupPhoneNumbersRoute:
    AuthOrgIdSettingsBusinessSetupPhoneNumbersRoute,
  AuthOrgIdSettingsCalendarAppointmentsCancelRescheduleRoute:
    AuthOrgIdSettingsCalendarAppointmentsCancelRescheduleRoute,
  AuthOrgIdSettingsCalendarAppointmentsDisplayPreferencesRoute:
    AuthOrgIdSettingsCalendarAppointmentsDisplayPreferencesRoute,
  AuthOrgIdSettingsCalendarAppointmentsNoShowProtectionRoute:
    AuthOrgIdSettingsCalendarAppointmentsNoShowProtectionRoute,
  AuthOrgIdSettingsCalendarAppointmentsSchedulingOptionsRoute:
    AuthOrgIdSettingsCalendarAppointmentsSchedulingOptionsRoute,
  AuthOrgIdSettingsOnlineBookingPreferencesRoute:
    AuthOrgIdSettingsOnlineBookingPreferencesRoute,
  AuthOrgIdSettingsOnlineBookingSetupIntegrationRoute:
    AuthOrgIdSettingsOnlineBookingSetupIntegrationRoute,
  AuthOrgIdSettingsOnlineBookingStaffSelectionRoute:
    AuthOrgIdSettingsOnlineBookingStaffSelectionRoute,
  AuthOrgIdSettingsServicesImportRoute: AuthOrgIdSettingsServicesImportRoute,
  AuthOrgIdSettingsServicesSameTimeRoute:
    AuthOrgIdSettingsServicesSameTimeRoute,
}

const AuthOrgIdRouteWithChildren = AuthOrgIdRoute._addFileChildren(
  AuthOrgIdRouteChildren,
)

interface AuthAgencyMembersRouteChildren {
  AuthAgencyMembersMemberIdRoute: typeof AuthAgencyMembersMemberIdRoute
  AuthAgencyMembersNewRoute: typeof AuthAgencyMembersNewRoute
  AuthAgencyMembersIndexRoute: typeof AuthAgencyMembersIndexRoute
}

const AuthAgencyMembersRouteChildren: AuthAgencyMembersRouteChildren = {
  AuthAgencyMembersMemberIdRoute: AuthAgencyMembersMemberIdRoute,
  AuthAgencyMembersNewRoute: AuthAgencyMembersNewRoute,
  AuthAgencyMembersIndexRoute: AuthAgencyMembersIndexRoute,
}

const AuthAgencyMembersRouteWithChildren =
  AuthAgencyMembersRoute._addFileChildren(AuthAgencyMembersRouteChildren)

interface AuthAgencyRouteChildren {
  AuthAgencyDemoRequestsRoute: typeof AuthAgencyDemoRequestsRoute
  AuthAgencyEinRoute: typeof AuthAgencyEinRoute
  AuthAgencyGoogleAdsRoute: typeof AuthAgencyGoogleAdsRoute
  AuthAgencyGoogleRankingRoute: typeof AuthAgencyGoogleRankingRoute
  AuthAgencyMembersRoute: typeof AuthAgencyMembersRouteWithChildren
  AuthAgencyMetaAdsRoute: typeof AuthAgencyMetaAdsRoute
  AuthAgencyProfileRoute: typeof AuthAgencyProfileRoute
  AuthAgencyRevenueCostsRoute: typeof AuthAgencyRevenueCostsRoute
  AuthAgencySalonResultsRoute: typeof AuthAgencySalonResultsRoute
  AuthAgencySocialResultsRoute: typeof AuthAgencySocialResultsRoute
  AuthAgencyWebsiteRoute: typeof AuthAgencyWebsiteRoute
  AuthAgencyIndexRoute: typeof AuthAgencyIndexRoute
  AuthAgencyAdsDoctorShortCodeRoute: typeof AuthAgencyAdsDoctorShortCodeRoute
  AuthAgencyAdsDoctorAskRoute: typeof AuthAgencyAdsDoctorAskRoute
  AuthAgencyCounterStandsProgramRoute: typeof AuthAgencyCounterStandsProgramRoute
  AuthAgencyGuidanceSlugRoute: typeof AuthAgencyGuidanceSlugRoute
  AuthAgencySalonsShortCodeRoute: typeof AuthAgencySalonsShortCodeRoute
  AuthAgencySalonsNewRoute: typeof AuthAgencySalonsNewRoute
  AuthAgencyAdsDoctorIndexRoute: typeof AuthAgencyAdsDoctorIndexRoute
  AuthAgencyGoogleBusinessIndexRoute: typeof AuthAgencyGoogleBusinessIndexRoute
  AuthAgencyGuidanceIndexRoute: typeof AuthAgencyGuidanceIndexRoute
  AuthAgencySalonsIndexRoute: typeof AuthAgencySalonsIndexRoute
}

const AuthAgencyRouteChildren: AuthAgencyRouteChildren = {
  AuthAgencyDemoRequestsRoute: AuthAgencyDemoRequestsRoute,
  AuthAgencyEinRoute: AuthAgencyEinRoute,
  AuthAgencyGoogleAdsRoute: AuthAgencyGoogleAdsRoute,
  AuthAgencyGoogleRankingRoute: AuthAgencyGoogleRankingRoute,
  AuthAgencyMembersRoute: AuthAgencyMembersRouteWithChildren,
  AuthAgencyMetaAdsRoute: AuthAgencyMetaAdsRoute,
  AuthAgencyProfileRoute: AuthAgencyProfileRoute,
  AuthAgencyRevenueCostsRoute: AuthAgencyRevenueCostsRoute,
  AuthAgencySalonResultsRoute: AuthAgencySalonResultsRoute,
  AuthAgencySocialResultsRoute: AuthAgencySocialResultsRoute,
  AuthAgencyWebsiteRoute: AuthAgencyWebsiteRoute,
  AuthAgencyIndexRoute: AuthAgencyIndexRoute,
  AuthAgencyAdsDoctorShortCodeRoute: AuthAgencyAdsDoctorShortCodeRoute,
  AuthAgencyAdsDoctorAskRoute: AuthAgencyAdsDoctorAskRoute,
  AuthAgencyCounterStandsProgramRoute: AuthAgencyCounterStandsProgramRoute,
  AuthAgencyGuidanceSlugRoute: AuthAgencyGuidanceSlugRoute,
  AuthAgencySalonsShortCodeRoute: AuthAgencySalonsShortCodeRoute,
  AuthAgencySalonsNewRoute: AuthAgencySalonsNewRoute,
  AuthAgencyAdsDoctorIndexRoute: AuthAgencyAdsDoctorIndexRoute,
  AuthAgencyGoogleBusinessIndexRoute: AuthAgencyGoogleBusinessIndexRoute,
  AuthAgencyGuidanceIndexRoute: AuthAgencyGuidanceIndexRoute,
  AuthAgencySalonsIndexRoute: AuthAgencySalonsIndexRoute,
}

const AuthAgencyRouteWithChildren = AuthAgencyRoute._addFileChildren(
  AuthAgencyRouteChildren,
)

interface AuthRouteChildren {
  AuthOrgIdRoute: typeof AuthOrgIdRouteWithChildren
  AuthAgencyRoute: typeof AuthAgencyRouteWithChildren
  AuthChooseSalonRoute: typeof AuthChooseSalonRoute
  AuthGuidanceRoute: typeof AuthGuidanceRoute
  AuthGoogleBusinessCallbackRoute: typeof AuthGoogleBusinessCallbackRoute
  AuthMetaCommentToDmCallbackRoute: typeof AuthMetaCommentToDmCallbackRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthOrgIdRoute: AuthOrgIdRouteWithChildren,
  AuthAgencyRoute: AuthAgencyRouteWithChildren,
  AuthChooseSalonRoute: AuthChooseSalonRoute,
  AuthGuidanceRoute: AuthGuidanceRoute,
  AuthGoogleBusinessCallbackRoute: AuthGoogleBusinessCallbackRoute,
  AuthMetaCommentToDmCallbackRoute: AuthMetaCommentToDmCallbackRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface DevRouteChildren {
  DevUiPreviewInputsRoute: typeof DevUiPreviewInputsRoute
  DevUiPreviewIndexRoute: typeof DevUiPreviewIndexRoute
}

const DevRouteChildren: DevRouteChildren = {
  DevUiPreviewInputsRoute: DevUiPreviewInputsRoute,
  DevUiPreviewIndexRoute: DevUiPreviewIndexRoute,
}

const DevRouteWithChildren = DevRoute._addFileChildren(DevRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  DevRoute: DevRouteWithChildren,
  LoginRoute: LoginRoute,
  SignInRoute: SignInRoute,
  SignUpRoute: SignUpRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
